(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-about-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Carousel arrows (Values + Engineering).
     Mobile/tablet only in practice — arrows are hidden on desktop via CSS,
     so these listeners are harmless there. Scrolls one card per tap. */
  document.querySelectorAll('.a-carousel-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.a-vg, .a-eng-list');
    var prev  = wrap.querySelector('.a-carousel-arrow--prev');
    var next  = wrap.querySelector('.a-carousel-arrow--next');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return 280;
      var gap = parseInt(window.getComputedStyle(track).gap || '16', 10);
      return card.offsetWidth + gap;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });
  });

  /* Founder flip card (mobile only). Only enable the tap-to-flip if there are
     two faces; with a single founder it just shows that one card. */
  var fflip = document.getElementById('a-fflip');
  if (fflip) {
    var front = fflip.querySelector('.a-fflip__face--front');
    var back  = fflip.querySelector('.a-fflip__face--back');

    if (front && back) {
      function setFlipHeight() {
        var target = fflip.classList.contains('flipped') ? back : front;
        fflip.style.height = target.offsetHeight + 'px';
      }
      setFlipHeight();
      window.addEventListener('load', setFlipHeight);
      window.addEventListener('resize', setFlipHeight);

      fflip.addEventListener('click', function () {
        fflip.classList.toggle('flipped');
        setFlipHeight();
      });
    } else {
      fflip.style.cursor = 'default';
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  // recommendation "Add" buttons -> /cart/add.js for the specific variant, then reload
  document.querySelectorAll('.t-cross-add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) {
        if (r.ok) { window.location.reload(); return; }
        return r.json().then(function (err) {
          btn.textContent = 'Unavailable';
          if (window.ThinklyCart) {
            window.ThinklyCart.showToast(err.description || err.message || 'Could not add this item.');
          }
        });
      }).catch(function () {
        btn.disabled = false;
      });
    });
  });

  // quantity + remove -> /cart/change.js, then reload to reflect new totals
  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) {
      if (r.ok) { window.location.reload(); return; }
      return r.json().then(function (err) {
        if (window.ThinklyCart) {
          window.ThinklyCart.showToast(err.description || err.message || 'Could not update your cart.');
        }
      });
    });
  }

  document.querySelectorAll('.t-qty-minus, .t-qty-plus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var qty = parseInt(btn.getAttribute('data-qty'), 10);
      if (qty < 0) return;
      changeLine(line, qty);
    });
  });

  document.querySelectorAll('.t-remove').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var line = parseInt(link.getAttribute('data-line'), 10);
      changeLine(line, 0);
    });
  });
})();

// PRE-LAUNCH (temporary): at launch time, swap Pre-book back to the normal checkout button
(function () {
  var pre = document.getElementById('t-prebook-open');
  if (!pre) return;
  var launch = new Date(pre.getAttribute('data-launch')).getTime();
  if (isNaN(launch)) return;

  function check() {
    if (Date.now() < launch) return false;
    document.querySelectorAll('[data-pl-only]').forEach(function (el) { el.hidden = true; });
    document.querySelectorAll('[data-live-only]').forEach(function (el) { el.hidden = false; });
    var modal = document.getElementById('t-pb');
    if (modal) modal.hidden = true;
    document.body.style.overflow = '';
    return true;
  }

  if (!check()) {
    var t = setInterval(function () { if (check()) clearInterval(t); }, 1000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-contact-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

  if (!isTouch) {
    document.querySelectorAll('.topic-card, .qa-item, .sidebar-contact-item, .sidebar-toggle-btn').forEach(el => {
      el.addEventListener('mouseenter', () => {
        const marble = document.getElementById('cursor-marble');
        if (marble) marble.classList.add('large');
      });
      el.addEventListener('mouseleave', () => {
        const marble = document.getElementById('cursor-marble');
        if (marble) marble.classList.remove('large');
      });
    });
  }

  /* COLLAPSIBLE SIDEBAR */
  const sidebarToggleBtn = document.getElementById('sidebar-toggle-btn');
  if (sidebarToggleBtn) {
    sidebarToggleBtn.addEventListener('click', () => {
      const wrapper = document.getElementById('sidebar-collapsible-wrapper');
      const isOpen = wrapper.classList.toggle('open');
      if (isOpen) {
        sidebarToggleBtn.innerHTML = 'Hide contact options <span class="toggle-arrow" style="transform: rotate(180deg);">&#9660;</span>';
      } else {
        sidebarToggleBtn.innerHTML = 'Show all contact options <span class="toggle-arrow">&#9660;</span>';
      }
    });
  }

  /* TOPIC SELECTOR */
  const topicCards = document.querySelectorAll('.topic-card');
  const topicSelect = document.getElementById('f-topic');
  const formContextLine = document.getElementById('form-context-line');
  const orderGroup = document.getElementById('order-number-group');

  function toggleOrderField(show) {
    if (!orderGroup) return;
    if (show) {
      orderGroup.style.display = 'flex';
      orderGroup.offsetHeight;
      orderGroup.classList.add('visible');
    } else {
      orderGroup.classList.remove('visible');
      if (orderGroup.timeoutId) clearTimeout(orderGroup.timeoutId);
      orderGroup.timeoutId = setTimeout(() => {
        if (!orderGroup.classList.contains('visible')) orderGroup.style.display = 'none';
      }, 350);
    }
  }

  function setActiveTopic(topicKey, contextText) {
    topicCards.forEach(c => c.classList.toggle('active', c.dataset.topic === topicKey));
    if (topicSelect) {
      Array.from(topicSelect.options).forEach((opt, i) => {
        if (opt.value === topicKey) topicSelect.selectedIndex = i;
      });
    }
    if (formContextLine) formContextLine.textContent = contextText;
    toggleOrderField(topicKey === 'order' || topicKey === 'return');
  }

  topicCards.forEach(card => {
    card.addEventListener('click', () => {
      setActiveTopic(card.dataset.topic, card.dataset.context);
      if (!isTouch) {
        setTimeout(() => {
          const msg = document.getElementById('f-message');
          if (msg) msg.focus();
        }, 360);
      }
    });
  });

  if (topicSelect) {
    topicSelect.addEventListener('change', function () {
      const selectedCard = document.querySelector(`.topic-card[data-topic="${this.value}"]`);
      const contextText = selectedCard ? selectedCard.dataset.context : '';
      setActiveTopic(this.value, contextText);
    });
  }

  // Initialise default state from first topic card
  if (topicCards.length > 0) {
    setActiveTopic(topicCards[0].dataset.topic, topicCards[0].dataset.context);
  }

  /* FORM SUBMIT */
  const formSubmitBtn = document.getElementById('form-submit-btn');
  if (formSubmitBtn) {
    formSubmitBtn.addEventListener('click', () => {
      const name = document.getElementById('f-name').value.trim();
      const email = document.getElementById('f-email').value.trim();
      const message = document.getElementById('f-message').value.trim();
      const topicSelectEl = document.getElementById('f-topic');
      const topicText = topicSelectEl.options[topicSelectEl.selectedIndex].text;
      const orderInput = document.getElementById('f-order');
      const orderNum = orderInput ? orderInput.value.trim() : '';

      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (!name || !emailValid || !message) {
        document.getElementById('f-name').style.borderColor = name ? '' : 'var(--gold)';
        document.getElementById('f-email').style.borderColor = emailValid ? '' : 'var(--gold)';
        document.getElementById('f-message').style.borderColor = message ? '' : 'var(--gold)';
        return;
      }

      formSubmitBtn.textContent = 'Sending...';
      formSubmitBtn.style.opacity = '0.7';

      const subject = encodeURIComponent(`Contact Form: ${topicText}`);
      let bodyContent = `Name: ${name}\nEmail: ${email}\nTopic: ${topicText}\n`;
      if (orderNum) bodyContent += `Order Number: ${orderNum}\n`;
      bodyContent += `\nMessage:\n${message}`;
      const body = encodeURIComponent(bodyContent);
      const mailtoLink = `mailto:{{ section.settings.contact_email }}?subject=${subject}&body=${body}`;

      window.location.href = mailtoLink;

      setTimeout(() => {
        document.getElementById('contact-form').style.opacity = '0.3';
        document.getElementById('contact-form').style.pointerEvents = 'none';
        document.getElementById('success-email').textContent = email;
        document.getElementById('form-success').classList.add('visible');
        formSubmitBtn.textContent = 'Sent \u2713';
        formSubmitBtn.classList.add('sent');
        formSubmitBtn.style.opacity = '1';
      }, 900);
    });
  }

  /* FAQ ACCORDION */
  document.querySelectorAll('.qa-item').forEach(item => {
    item.addEventListener('click', () => {
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.qa-item.open').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* SCROLL REVEAL */
  const contactObs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.06, rootMargin: '0px 0px -32px 0px' });

  document.querySelectorAll('.reveal').forEach(el => contactObs.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-enemy-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  var toggle = document.getElementById('t-enemy-toggle');
  var collapse = document.getElementById('t-enemy-collapse');
  if (!toggle || !collapse) return;

  var label = toggle.querySelector('.t-enemy-toggle-text');

  toggle.addEventListener('click', function () {
    var expanded = collapse.classList.toggle('expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (label) label.textContent = expanded ? 'Read less' : 'Read more';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-faq-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Self-contained accordion — fully namespaced, no class collisions with other sections
  document.addEventListener('click', function(e) {
    var item = e.target.closest('.t-faqpage-item');
    if (!item) return;

    var isOpen = item.classList.contains('open');

    // Close all open items in same section (accordion behavior)
    var section = item.closest('.t-faqpage-section');
    if (section) {
      section.querySelectorAll('.t-faqpage-item.open').forEach(function(el) {
        el.classList.remove('open');
      });
    }

    if (!isOpen) item.classList.add('open');
  });

  /* ── SIDEBAR OBSERVER ── */

  var thinklyFaqSections = document.querySelectorAll('.t-faqpage-section');
  var thinklyFaqLinks = document.querySelectorAll('.t-faqpage-sidebar__link');

  var thinklyFaqObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        thinklyFaqLinks.forEach(function (l) { l.classList.remove('active'); });
        var link = document.querySelector('.t-faqpage-sidebar__link[href="#' + e.target.id + '"]');
        if (link) {
          link.classList.add('active');
          var nav = document.querySelector('.t-faqpage-sidebar__nav');
          if (nav && window.innerWidth <= 960) {
            var navRect = nav.getBoundingClientRect();
            var linkRect = link.getBoundingClientRect();
            var offset = linkRect.left - navRect.left + nav.scrollLeft - (navRect.width / 2) + (linkRect.width / 2);
            nav.scrollTo({ left: offset, behavior: 'smooth' });
          }
        }
      }
    });
  }, { threshold: 0.3, rootMargin: '-80px 0px -60% 0px' });

  thinklyFaqSections.forEach(function (s) { thinklyFaqObserver.observe(s); });

  thinklyFaqLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = link.getAttribute('href');
      var targetSection = document.querySelector(targetId);
      if (targetSection) {
        document.querySelectorAll('.t-faqpage-section, .reveal').forEach(function (el) {
          if (!el.classList.contains('visible')) {
            el.style.transition = 'none';
            el.classList.add('visible');
            void el.offsetHeight;
            setTimeout(function () { el.style.transition = ''; }, 50);
          }
        });
        targetSection.scrollIntoView({ behavior: 'smooth' });
        history.pushState(null, null, targetId);
        thinklyFaqLinks.forEach(function (l) { l.classList.remove('active'); });
        link.classList.add('active');
      }
    });
  });

  var thinklyFaqSearchInput = document.getElementById('faq-search');
  var thinklyFaqSearchClear = document.getElementById('search-clear');
  var thinklyFaqNoResults = document.getElementById('faq-no-results');
  var thinklyFaqSidebar = document.querySelector('.t-faqpage-sidebar');

  function thinklyFaqPerformSearch(query) {
    query = query.trim().toLowerCase();

    if (query.length === 0) {
      thinklyFaqClearSearch();
      return;
    }

    thinklyFaqSearchClear.style.display = 'flex';

    if (thinklyFaqSidebar) {
      thinklyFaqSidebar.style.visibility = 'hidden';
      thinklyFaqSidebar.style.opacity = '0';
      thinklyFaqSidebar.style.pointerEvents = 'none';
    }

    var totalMatches = 0;

    thinklyFaqSections.forEach(function (section) {
      var sectionHasMatch = false;
      var items = section.querySelectorAll('.t-faqpage-item');

      items.forEach(function (item) {
        var question = item.querySelector('.t-faqpage-q').textContent.toLowerCase();
        var answer = item.querySelector('.t-faqpage-a').textContent.toLowerCase();
        var isMatch = question.indexOf(query) !== -1 || answer.indexOf(query) !== -1;

        if (isMatch) {
          item.style.display = 'block';
          item.classList.remove('open');
          sectionHasMatch = true;
          totalMatches++;
        } else {
          item.style.display = 'none';
          item.classList.remove('open');
        }
      });

      if (sectionHasMatch) {
        section.style.display = 'block';
        section.classList.add('visible');
      } else {
        section.style.display = 'none';
      }
    });

    thinklyFaqNoResults.style.display = totalMatches === 0 ? 'block' : 'none';
  }

  function thinklyFaqClearSearch() {
    thinklyFaqSearchInput.value = '';
    thinklyFaqSearchClear.style.display = 'none';
    thinklyFaqNoResults.style.display = 'none';

    if (thinklyFaqSidebar) {
      thinklyFaqSidebar.style.visibility = 'visible';
      thinklyFaqSidebar.style.opacity = '1';
      thinklyFaqSidebar.style.pointerEvents = 'auto';
    }

    thinklyFaqSections.forEach(function (section) {
      section.style.display = 'block';
      section.querySelectorAll('.t-faqpage-item').forEach(function (item) {
        item.style.display = 'block';
        item.classList.remove('open');
      });
    });
  }

  if (thinklyFaqSearchInput) {
    thinklyFaqSearchInput.addEventListener('input', function (e) { thinklyFaqPerformSearch(e.target.value); });
  }
  if (thinklyFaqSearchClear) {
    thinklyFaqSearchClear.addEventListener('click', thinklyFaqClearSearch);
  }

  var thinklyFaqRevealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.06, rootMargin: '0px 0px -32px 0px' });

  document.querySelectorAll('.reveal').forEach(function (el) { thinklyFaqRevealObs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-fit-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Add-to-cart for the Fit product page.
  // Reuses the same pattern as the Flow comparison table's cart buttons:
  // POST to /cart/add.js, show inline confirmation, bump header cart badge.
  document.querySelectorAll('.t-fitp-hero__buy-btn, .t-fitp-final__buy-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added \u2713';
        btn.classList.add('added');

        var badge = document.getElementById('t-cart-badge');
        if (badge) {
          var current = parseInt(badge.textContent, 10) || 0;
          badge.textContent = current + 1;
          badge.classList.add('pop');
          setTimeout(function () { badge.classList.remove('pop'); }, 250);
        }

        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('added');
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-flow-series"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Tap-to-toggle tooltips on touch devices (hover doesn't exist there).
  // Applies to both the table's block-types tooltips and the kit card description tooltips,
  // since both reuse the same .t-kt-tooltip-trigger / .t-kt-tooltip-wrap classes.
  document.querySelectorAll('.t-kt-tooltip-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      var wrap = trigger.closest('.t-kt-tooltip-wrap');
      var wasOpen = wrap.classList.contains('t-kt-tooltip-open');

      document.querySelectorAll('.t-kt-tooltip-wrap.t-kt-tooltip-open').forEach(function(openWrap) {
        openWrap.classList.remove('t-kt-tooltip-open');
      });

      if (!wasOpen) wrap.classList.add('t-kt-tooltip-open');
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.t-kt-tooltip-wrap')) {
      document.querySelectorAll('.t-kt-tooltip-wrap.t-kt-tooltip-open').forEach(function(openWrap) {
        openWrap.classList.remove('t-kt-tooltip-open');
      });
    }
  });

  // Add-to-cart from the comparison table.
  // Fetches /cart/add.js. Only a request Shopify accepted shows "Added" and updates
  // the cart count. If Shopify refuses (e.g. the kit just sold out), the button
  // goes back to normal and Shopify's reason is shown in a toast.
  document.querySelectorAll('.t-kt-add:not(.t-kt-add--out)').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.data && res.data.description) ? res.data.description : 'Could not add this item.';
          if (window.ThinklyCart) window.ThinklyCart.showToast(msg);
          btn.textContent = originalText;
          btn.disabled = false;
          return;
        }

        btn.textContent = 'Added \u2713';
        btn.classList.add('added');

        if (window.ThinklyCart) {
          // Re-reads the real cart, so the header count and dropdown stay correct
          window.ThinklyCart.refresh();
        } else {
          var badge = document.getElementById('t-cart-badge');
          if (badge) {
            var current = parseInt(badge.textContent, 10) || 0;
            badge.textContent = current + 1;
            badge.classList.add('pop');
            setTimeout(function () { badge.classList.remove('pop'); }, 250);
          }
        }

        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('added');
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-gifting-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var thinklyGiftSection = document.querySelector('.gf-enquiry');
  var thinklyGiftFormAction = thinklyGiftSection ? thinklyGiftSection.dataset.formAction : '';
  var thinklyGiftFieldMap = thinklyGiftSection ? {
    name: thinklyGiftSection.dataset.entryName,
    company: thinklyGiftSection.dataset.entryCompany,
    email: thinklyGiftSection.dataset.entryEmail,
    phone: thinklyGiftSection.dataset.entryPhone,
    message: thinklyGiftSection.dataset.entryMessage
  } : {};
  var thinklyGiftEmailTo = thinklyGiftSection ? thinklyGiftSection.dataset.notificationEmail : '';

  function thinklyGiftHighlight(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.style.borderColor = 'rgba(245,166,35,0.8)';
    el.focus();
    setTimeout(function() { el.style.borderColor = ''; }, 2500);
  }

  function thinklyGiftSubmitForm() {
    var name = document.getElementById('gf-name').value.trim();
    var company = document.getElementById('gf-company').value.trim();
    var email = document.getElementById('gf-email').value.trim();
    var phone = document.getElementById('gf-phone').value.trim();
    var qty = document.getElementById('gf-qty').value;
    var message = document.getElementById('gf-message').value.trim();

    if (!name) { thinklyGiftHighlight('gf-name'); return; }
    if (!company) { thinklyGiftHighlight('gf-company'); return; }
    var emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!emailValid) { thinklyGiftHighlight('gf-email'); return; }
    if (!phone || phone.length < 8) { thinklyGiftHighlight('gf-phone'); return; }

    var fullMessage = 'Quantity: ' + (qty || 'Not specified') + '\n\nRequirements: ' + (message || 'None specified');

    if (thinklyGiftFormAction && thinklyGiftFieldMap.name) {
      var iframe = document.createElement('iframe');
      iframe.name = 'thinkly_gift_hidden_iframe';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      var form = document.createElement('form');
      form.method = 'POST';
      form.action = thinklyGiftFormAction;
      form.target = 'thinkly_gift_hidden_iframe';

      var fields = {};
      fields[thinklyGiftFieldMap.name] = name;
      fields[thinklyGiftFieldMap.company] = company;
      fields[thinklyGiftFieldMap.email] = email;
      fields[thinklyGiftFieldMap.phone] = phone;
      fields[thinklyGiftFieldMap.message] = fullMessage;

      Object.keys(fields).forEach(function(k) {
        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = k;
        i.value = fields[k];
        form.appendChild(i);
      });
      document.body.appendChild(form);
      form.submit();
    }

    if (thinklyGiftEmailTo) {
      var subject = encodeURIComponent('Thinkly Corporate Gifting Enquiry - ' + company);
      var bodyContent = 'Name: ' + name + '\nCompany: ' + company + '\nEmail: ' + email + '\nPhone: ' + phone + '\nQuantity: ' + (qty || 'Not specified') + '\n\nRequirements:\n' + (message || 'None specified');
      var body = encodeURIComponent(bodyContent);
      window.location.href = 'mailto:' + thinklyGiftEmailTo + '?subject=' + subject + '&body=' + body;
    }

    document.getElementById('gf-form-card').style.display = 'none';
    document.getElementById('gf-form-success').style.display = 'block';
  }

  var thinklyGiftSubmitBtn = document.getElementById('gf-submit-btn');
  if (thinklyGiftSubmitBtn) {
    thinklyGiftSubmitBtn.addEventListener('click', thinklyGiftSubmitForm);
  }

  var thinklyGiftRevealObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.06, rootMargin: '0px 0px -32px 0px' });

  document.querySelectorAll('.reveal').forEach(function(el) { thinklyGiftRevealObs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-hero-video-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.t-hero-v2--carousel').forEach(function (section) {
    var slides = section.querySelectorAll('.t-hero-v2__slide');
    var dots = section.querySelectorAll('.t-hero-v2__dot');
    var prev = section.querySelector('.t-hero-v2__arrow--prev');
    var next = section.querySelector('.t-hero-v2__arrow--next');
    var videos = section.querySelectorAll('.t-hero-v2__video');
    var autoplayMs = parseInt(section.dataset.autoplayMs, 10) || 6000;

    if (slides.length < 2) return;

    var current = 0;
    var timer = null;

    function playCurrentVideo() {
      videos.forEach(function (v, i) {
        if (i === current) {
          // Play the newly active video from wherever it is
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }

    function goTo(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === current);
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === current);
      });
      playCurrentVideo();
    }

    function nextSlide() { goTo(current + 1); }
    function prevSlide() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(nextSlide, autoplayMs);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (next) next.addEventListener('click', function () { nextSlide(); startAutoplay(); });
    if (prev) prev.addEventListener('click', function () { prevSlide(); startAutoplay(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.dataset.dotIndex, 10));
        startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    playCurrentVideo();
    startAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-marbles-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var pills = document.querySelectorAll('.mp-vpill-input');
  var variantInput = document.getElementById('mp-variant-input');
  var priceDisplay = document.getElementById('mp-price');
  var btnPriceDisplay = document.getElementById('mp-btn-price');

  // Read variant price data from the JSON script tag rendered by Liquid in the HTML above.
  // (Liquid is not processed inside {% javascript %} blocks, so this data must be
  // rendered separately in the HTML and read here via the DOM.)
  var variantPrices = {};
  var variantDataEl = document.getElementById('mp-variant-data');
  if (variantDataEl) {
    try {
      variantPrices = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      console.error('Failed to parse variant price data', e);
    }
  }

  pills.forEach(function(input) {
    input.addEventListener('change', function() {
      document.querySelectorAll('.mp-vpill').forEach(function(p) { p.classList.remove('active'); });
      input.closest('.mp-vpill').classList.add('active');

      if (variantInput) variantInput.value = input.value;

      var newPrice = variantPrices[input.value];
      if (newPrice) {
        if (priceDisplay) priceDisplay.textContent = newPrice;
        if (btnPriceDisplay) btnPriceDisplay.textContent = newPrice;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-privacy"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Smooth scroll for table of contents links
  document.querySelectorAll('.t-policy-toc__list a').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var targetId = link.getAttribute('href');
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
        history.pushState(null, null, targetId);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-product-care"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.tp-care-carousel-wrap').forEach(function (wrap) {
    var grid = wrap.querySelector('.tp-care-items');
    var prev = wrap.querySelector('.tp-care-arrow--prev');
    var next = wrap.querySelector('.tp-care-arrow--next');
    if (!grid || !prev || !next) return;

    function cardScrollWidth() {
      var card = grid.querySelector('.tp-care-item');
      if (!card) return 280;
      var gap = parseInt(window.getComputedStyle(grid).gap || '16');
      return card.offsetWidth + gap;
    }

    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -cardScrollWidth(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      grid.scrollBy({ left: cardScrollWidth(), behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-product-comparison"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Tap-to-toggle tooltips on touch devices (hover doesn't exist there)
  document.querySelectorAll('.tp-kt-tooltip-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      var wrap = trigger.closest('.tp-kt-tooltip-wrap');
      var wasOpen = wrap.classList.contains('tp-kt-tooltip-open');

      document.querySelectorAll('.tp-kt-tooltip-wrap.tp-kt-tooltip-open').forEach(function(openWrap) {
        openWrap.classList.remove('tp-kt-tooltip-open');
      });

      if (!wasOpen) wrap.classList.add('tp-kt-tooltip-open');
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.tp-kt-tooltip-wrap')) {
      document.querySelectorAll('.tp-kt-tooltip-wrap.tp-kt-tooltip-open').forEach(function(openWrap) {
        openWrap.classList.remove('tp-kt-tooltip-open');
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-product-final-cta"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var finalForm  = document.getElementById('tp-final-form');
  var fctaBtn    = document.getElementById('fcta-btn');
  var finalVariantInput = document.getElementById('tp-final-variant-input');

  /* Live stock safety net: if Shopify refuses an add, show its reason and
     re-check this variant, switching the button to "Sold out" if needed. */
  function markSoldOut() {
    if (!fctaBtn) return;
    fctaBtn.disabled = true;
    fctaBtn.setAttribute('aria-disabled', 'true');
    fctaBtn.classList.remove('is-loading');
    fctaBtn.classList.add('tp-final-btn--soldout');
    fctaBtn.textContent = 'Sold out';
  }

  function syncAvailability() {
    if (!finalForm || !finalForm.dataset.productHandle || !finalVariantInput) return;
    fetch('/products/' + finalForm.dataset.productHandle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p || !p.variants) return;
        var vid = parseInt(finalVariantInput.value, 10);
        var match = p.variants.filter(function(v) { return v.id === vid; })[0];
        if (match && match.available === false) markSoldOut();
      })
      .catch(function() { /* best-effort */ });
  }

  if (finalForm) {
    finalForm.addEventListener('submit', function(e) {
      // A sold-out variant can never be added
      if (fctaBtn && fctaBtn.disabled) { e.preventDefault(); return; }
      if (!window.ThinklyCart) return;
      e.preventDefault();
      if (fctaBtn && fctaBtn.classList.contains('is-loading')) return;

      var kitTitle = finalForm.dataset.productTitle || '';
      var originalText = fctaBtn ? fctaBtn.textContent : '';
      if (fctaBtn) {
        fctaBtn.classList.add('is-loading');
        fctaBtn.textContent = 'Adding…';
      }

      window.ThinklyCart.addItems(
        [{ id: parseInt(finalVariantInput.value, 10), quantity: 1 }],
        { toastMessage: kitTitle + ' added to cart!' }
      )
        .then(function() {
          if (fctaBtn) {
            fctaBtn.classList.remove('is-loading');
            fctaBtn.textContent = originalText;
          }
        })
        .catch(function(err) {
          console.error('Thinkly final CTA add to cart failed', err);
          if (fctaBtn) {
            fctaBtn.classList.remove('is-loading');
            fctaBtn.textContent = originalText;
          }
          // Shopify's own reason, e.g. "already sold out" or "only 2 available"
          var msg = (err && err.description) ? err.description : 'Something went wrong. Please try again.';
          window.ThinklyCart.showToast(msg);
          syncAvailability();
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-product-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* ─────────────────────────────────────────
     NOTE: Kit switching (Starter/Explorer/Master) is handled via
     real page navigation — the variant pills and upgrade path are
     all <a href> links to the sibling products' own pages. No
     client-side variant-swap logic is needed here.
  ───────────────────────────────────────── */

  /* ─────────────────────────────────────────
     IMAGE GALLERY
  ───────────────────────────────────────── */
  var slider     = document.getElementById('product-slider');
  var thumbRail  = document.getElementById('thumb-rail');
  var slides     = slider ? slider.querySelectorAll('.tp-slide') : [];
  var thumbs     = thumbRail ? thumbRail.querySelectorAll('.tp-thumb') : [];
  var currentSlide = 0;

  function goToSlide(index) {
    if (!slider || slides.length === 0) return;
    index = Math.max(0, Math.min(index, slides.length - 1));
    currentSlide = index;
    slider.scrollTo({ left: slider.offsetWidth * index, behavior: 'smooth' });
    thumbs.forEach(function(t, i) { t.classList.toggle('active', i === index); });
  }

  if (document.getElementById('gallery-prev')) {
    document.getElementById('gallery-prev').addEventListener('click', function() { goToSlide(currentSlide - 1); });
  }
  if (document.getElementById('gallery-next')) {
    document.getElementById('gallery-next').addEventListener('click', function() { goToSlide(currentSlide + 1); });
  }

  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() { goToSlide(i); });
  });

  // Sync active thumb when slider is scrolled manually
  if (slider) {
    slider.addEventListener('scroll', function() {
      var idx = Math.round(slider.scrollLeft / slider.offsetWidth);
      thumbs.forEach(function(t, i) { t.classList.toggle('active', i === idx); });
      currentSlide = idx;
    }, { passive: true });
  }

  /* ─────────────────────────────────────────
     ADD TO CART setup (declared early so the
     bump pill handlers below can use them)
  ───────────────────────────────────────── */
  var productForm   = document.getElementById('tp-product-form');
  var buyBtn        = document.getElementById('buy-btn');
  var variantInput  = document.getElementById('tp-variant-input');
  var addonCheckbox = document.getElementById('addon-marbles');

  function formatMoney(cents) {
    var amount = (cents || 0) / 100;
    return '₹' + amount.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function updateBuyButtonPrice() {
    // A sold-out button keeps its "Sold out" label
    if (!buyBtn || buyBtn.disabled || buyBtn.classList.contains('is-loading')) return;
    var basePrice = parseInt(buyBtn.dataset.basePrice || '0', 10);
    var total = basePrice;

    if (addonCheckbox && addonCheckbox.checked) {
      var activePill = document.querySelector('.tp-bump-pill.active');
      var addonCents = activePill ? parseInt(activePill.dataset.priceCents || '0', 10) : 0;
      total += addonCents;
    }

    buyBtn.textContent = 'Add to cart · ' + formatMoney(total);
  }

  /* ─────────────────────────────────────────
     LIVE STOCK SAFETY NET
     The page can be a little out of date (someone opens it while in stock,
     it sells out, they tap Add). When Shopify refuses an add, we show its
     plain-language reason and re-check this variant's availability.
  ───────────────────────────────────────── */
  function markSoldOut() {
    if (!buyBtn) return;
    buyBtn.disabled = true;
    buyBtn.setAttribute('aria-disabled', 'true');
    buyBtn.classList.remove('is-loading');
    buyBtn.classList.add('tp-buy-btn--soldout');
    buyBtn.textContent = 'Sold out';
    if (addonCheckbox) {
      addonCheckbox.checked = false;
      addonCheckbox.disabled = true;
    }

    // Stock line under the price: replace any "Last few left" with "Out of stock"
    var wrap = document.querySelector('.tp-price-wrap');
    if (wrap) {
      var oldLine = document.getElementById('p-stock');
      if (oldLine && oldLine.parentNode) oldLine.parentNode.removeChild(oldLine);
      var line = document.createElement('div');
      line.className = 'tp-stock tp-stock--out';
      line.id = 'p-stock';
      line.innerHTML = '<span class="tp-stock-dot" aria-hidden="true"></span>Out of stock';
      wrap.appendChild(line);
    }

    // This kit's own (filled) pill says "Sold out" in place of its price
    var activePrice = document.querySelector('.tp-vpill.active .tp-vpill-price');
    if (activePrice) activePrice.textContent = 'Sold out';
  }

  function syncAvailability() {
    if (!productForm || !productForm.dataset.productHandle || !variantInput) return;
    fetch('/products/' + productForm.dataset.productHandle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p || !p.variants) return;
        var vid = parseInt(variantInput.value, 10);
        var match = p.variants.filter(function(v) { return v.id === vid; })[0];
        if (match && match.available === false) markSoldOut();
      })
      .catch(function() { /* the safety net is best-effort */ });
  }

  /* ─────────────────────────────────────────
     ACCESSORY BUMP PILLS
  ───────────────────────────────────────── */
  var bumpPills = document.querySelectorAll('.tp-bump-pill');

  function selectPill(pill) {
    bumpPills.forEach(function(p) { p.classList.remove('active'); });
    pill.classList.add('active');

    var price = pill.dataset.price || '';
    var priceLabel = document.getElementById('addon-price-label');
    if (priceLabel) priceLabel.textContent = price;

    var aloneBtn = document.getElementById('addon-alone-btn');
    if (aloneBtn) {
      aloneBtn.textContent = 'Buy ' + (pill.dataset.pack || '') + ' alone for ' + price;
    }

    updateBuyButtonPrice();
  }

  bumpPills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      if (pill.disabled) return;
      selectPill(pill);
    });
  });

  // If the default pack is sold out, start on the first pack that is in stock.
  // If every pack is sold out, switch the whole add-on off.
  (function initBumpAvailability() {
    var current = document.querySelector('.tp-bump-pill.active');
    if (!current || !current.disabled) return;
    var firstOk = null;
    bumpPills.forEach(function(p) { if (!firstOk && !p.disabled) firstOk = p; });
    if (firstOk) {
      selectPill(firstOk);
    } else {
      current.classList.remove('active');
      if (addonCheckbox) { addonCheckbox.checked = false; addonCheckbox.disabled = true; }
      var priceLabel = document.getElementById('addon-price-label');
      if (priceLabel) priceLabel.textContent = 'Sold out';
      var aloneBtn = document.getElementById('addon-alone-btn');
      if (aloneBtn) aloneBtn.style.display = 'none';
    }
  })();

  if (addonCheckbox) {
    addonCheckbox.addEventListener('change', updateBuyButtonPrice);
  }

  /* ─────────────────────────────────────────
     BUY MARBLES ALONE (no kit — just the addon)
  ───────────────────────────────────────── */
  var aloneBtnEl = document.getElementById('addon-alone-btn');
  if (aloneBtnEl) {
    aloneBtnEl.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation(); // don't let the click bubble up and toggle the checkbox
      if (!window.ThinklyCart) return;

      var activePill = document.querySelector('.tp-bump-pill.active');
      if (!activePill || !activePill.dataset.variantId) {
        window.ThinklyCart.showToast('Please select a pack size.');
        return;
      }

      var variantId = parseInt(activePill.dataset.variantId, 10);
      var packLabel = activePill.dataset.pack || 'Marbles';

      window.ThinklyCart.addItems(
        [{ id: variantId, quantity: 1 }],
        { toastMessage: packLabel + ' added to cart!' }
      ).catch(function(err) {
        var msg = (err && err.description) ? err.description : 'Something went wrong. Please try again.';
        window.ThinklyCart.showToast(msg);
      });
    });
  }

  /* ─────────────────────────────────────────
     ADD TO CART (AJAX, with optional marbles bundle)
  ───────────────────────────────────────── */
  function getSelectedMarblesLine() {
    var activePill = document.querySelector('.tp-bump-pill.active');
    if (!activePill || !activePill.dataset.variantId || activePill.disabled) return null;
    return {
      id: parseInt(activePill.dataset.variantId, 10),
      quantity: 1,
      label: activePill.dataset.pack || ''
    };
  }

  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      // A sold-out variant can never be added
      if (buyBtn && buyBtn.disabled) { e.preventDefault(); return; }
      // If the cart module hasn't loaded yet, fall back to a normal form submit.
      if (!window.ThinklyCart) return;
      e.preventDefault();
      if (buyBtn && buyBtn.classList.contains('is-loading')) return;

      var kitTitle = productForm.dataset.productTitle || '';
      var items = [{ id: parseInt(variantInput.value, 10), quantity: 1 }];
      var marblesLine = null;

      if (addonCheckbox && addonCheckbox.checked) {
        marblesLine = getSelectedMarblesLine();
        if (marblesLine) items.push({ id: marblesLine.id, quantity: marblesLine.quantity });
      }

      var toastMessage = marblesLine
        ? kitTitle + ' + ' + marblesLine.label + ' Marbles added to cart!'
        : kitTitle + ' added to cart!';

      if (buyBtn) {
        buyBtn.classList.add('is-loading');
        buyBtn.textContent = 'Adding…';
      }

      window.ThinklyCart.addItems(items, { toastMessage: toastMessage })
        .then(function() {
          if (buyBtn) {
            buyBtn.classList.remove('is-loading');
            updateBuyButtonPrice();
          }
        })
        .catch(function(err) {
          console.error('Thinkly add to cart failed', err);
          if (buyBtn) {
            buyBtn.classList.remove('is-loading');
            updateBuyButtonPrice();
          }
          // Shopify's own reason, e.g. "Only 2 available" or "already sold out"
          var msg = (err && err.description) ? err.description : 'Something went wrong. Please try again.';
          window.ThinklyCart.showToast(msg);
          syncAvailability();
        });
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-product-howitworks"] && !Shopify.designMode) return;
  try {
    
(function () {
  var toggle = document.getElementById('tp-steps-toggle');
  var steps = document.getElementById('tp-steps');
  if (!toggle || !steps) return;

  var label = toggle.querySelector('.tp-steps-toggle-text');

  toggle.addEventListener('click', function () {
    var expanded = steps.classList.toggle('expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (label) label.textContent = expanded ? 'Show less' : 'See how it works';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-product-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var stickyBar = document.getElementById('sticky-bar');
  var buyPanel  = document.getElementById('buy-btn');

  if (stickyBar && buyPanel) {
    var stickyObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        stickyBar.classList.toggle('visible', !e.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObs.observe(buyPanel);
  }

  /* ─────────────────────────────────────────
     ADD TO CART (AJAX)
  ───────────────────────────────────────── */
  var stickyForm = document.getElementById('tp-sticky-form');
  var stickyBtn  = document.getElementById('sticky-btn');
  var stickyVariantInput = document.getElementById('tp-sticky-variant-input');

  /* Live stock safety net: if Shopify refuses an add, show its reason and
     re-check this variant, switching the button to "Sold out" if needed. */
  function markSoldOut() {
    if (!stickyBtn) return;
    stickyBtn.disabled = true;
    stickyBtn.setAttribute('aria-disabled', 'true');
    stickyBtn.classList.remove('is-loading');
    stickyBtn.classList.add('tp-sticky__btn--soldout');
    stickyBtn.textContent = 'Sold out';
  }

  function syncAvailability() {
    if (!stickyForm || !stickyForm.dataset.productHandle || !stickyVariantInput) return;
    fetch('/products/' + stickyForm.dataset.productHandle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p || !p.variants) return;
        var vid = parseInt(stickyVariantInput.value, 10);
        var match = p.variants.filter(function(v) { return v.id === vid; })[0];
        if (match && match.available === false) markSoldOut();
      })
      .catch(function() { /* best-effort */ });
  }

  if (stickyForm) {
    stickyForm.addEventListener('submit', function(e) {
      // A sold-out variant can never be added
      if (stickyBtn && stickyBtn.disabled) { e.preventDefault(); return; }
      if (!window.ThinklyCart) return;
      e.preventDefault();
      if (stickyBtn && stickyBtn.classList.contains('is-loading')) return;

      var kitTitle = stickyForm.dataset.productTitle || '';
      var originalText = stickyBtn ? stickyBtn.textContent : '';
      if (stickyBtn) {
        stickyBtn.classList.add('is-loading');
        stickyBtn.textContent = 'Adding…';
      }

      window.ThinklyCart.addItems(
        [{ id: parseInt(stickyVariantInput.value, 10), quantity: 1 }],
        { toastMessage: kitTitle + ' added to cart!' }
      )
        .then(function() {
          if (stickyBtn) {
            stickyBtn.classList.remove('is-loading');
            stickyBtn.textContent = originalText;
          }
        })
        .catch(function(err) {
          console.error('Thinkly sticky add to cart failed', err);
          if (stickyBtn) {
            stickyBtn.classList.remove('is-loading');
            stickyBtn.textContent = originalText;
          }
          // Shopify's own reason, e.g. "already sold out" or "only 2 available"
          var msg = (err && err.description) ? err.description : 'Something went wrong. Please try again.';
          window.ThinklyCart.showToast(msg);
          syncAvailability();
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-product-unlocks"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var toggle   = document.getElementById('ku-toggle');
  var collapse = document.getElementById('ku-collapse');

  if (toggle && collapse) {
    toggle.addEventListener('click', function () {
      var expanded = collapse.classList.toggle('expanded');
      toggle.textContent = expanded ? 'Show less' : 'Show full details';
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-product-wood"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.tp-wood-carousel-wrap').forEach(function (wrap) {
    var grid = wrap.querySelector('.tp-wood-grid');
    var prev = wrap.querySelector('.tp-wood-arrow--prev');
    var next = wrap.querySelector('.tp-wood-arrow--next');
    if (!grid || !prev || !next) return;

    function cardScrollWidth() {
      var card = grid.querySelector('.tp-wood-card');
      if (!card) return 280;
      var gap = parseInt(window.getComputedStyle(grid).gap || '16');
      return card.offsetWidth + gap;
    }

    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -cardScrollWidth(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      grid.scrollBy({ left: cardScrollWidth(), behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-puzzle-game"] && !Shopify.designMode) return;
  try {
    
(function () {
'use strict';

const LEVELS_DATA = {
 "levels": [
{"level":1,"board":8,"difficulty":"easy","fixed_blocks":[{"x":3,"y":2,"w":3,"h":1},{"x":4,"y":6,"w":1,"h":2},{"x":1,"y":7,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":6,"y":2,"w":2,"h":4,"shape":"2x4"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":3,"w":1,"h":4,"shape":"1x4"},{"x":2,"y":3,"w":4,"h":3,"shape":"3x4"},{"x":2,"y":6,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":6,"w":3,"h":2,"shape":"2x3"}]},
  {"level":2,"board":8,"difficulty":"easy","fixed_blocks":[{"x":6,"y":3,"w":1,"h":2},{"x":1,"y":5,"w":1,"h":1},{"x":2,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":4,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":6,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":0,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":2,"w":3,"h":3,"shape":"3x3"},{"x":7,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":3,"y":5,"w":4,"h":3,"shape":"3x4"},{"x":0,"y":6,"w":2,"h":2,"shape":"2x2"}]},
  {"level":3,"board":8,"difficulty":"easy","fixed_blocks":[{"x":5,"y":4,"w":1,"h":2},{"x":4,"y":5,"w":1,"h":1},{"x":2,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":4,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":2,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":6,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":4,"board":8,"difficulty":"easy","fixed_blocks":[{"x":2,"y":0,"w":1,"h":3},{"x":7,"y":0,"w":1,"h":2},{"x":0,"y":6,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":3,"y":2,"w":5,"h":2,"shape":"2x5"},{"x":0,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":1,"y":6,"w":4,"h":1,"shape":"1x4"},{"x":0,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":5,"board":8,"difficulty":"easy","fixed_blocks":[{"x":1,"y":3,"w":1,"h":3},{"x":2,"y":5,"w":2,"h":1},{"x":6,"y":4,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":4,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":6,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":2,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":7,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":4,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":1,"y":6,"w":3,"h":2,"shape":"2x3"}]},
  {"level":6,"board":8,"difficulty":"easy","fixed_blocks":[{"x":5,"y":0,"w":1,"h":3},{"x":0,"y":1,"w":2,"h":1},{"x":1,"y":2,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":5,"h":1,"shape":"1x5"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":1,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":4,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":5,"w":4,"h":3,"shape":"3x4"},{"x":0,"y":6,"w":4,"h":2,"shape":"2x4"}]},
  {"level":7,"board":8,"difficulty":"easy","fixed_blocks":[{"x":5,"y":4,"w":1,"h":3},{"x":3,"y":5,"w":1,"h":2},{"x":0,"y":7,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":2,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":3,"w":1,"h":4,"shape":"1x4"},{"x":6,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":0,"y":5,"w":3,"h":2,"shape":"2x3"},{"x":1,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":8,"board":8,"difficulty":"easy","fixed_blocks":[{"x":2,"y":1,"w":1,"h":2},{"x":3,"y":1,"w":3,"h":1},{"x":0,"y":7,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":2,"y":0,"w":4,"h":1,"shape":"1x4"},{"x":6,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":2,"w":5,"h":2,"shape":"2x5"},{"x":0,"y":3,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":4,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":1,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":9,"board":8,"difficulty":"easy","fixed_blocks":[{"x":3,"y":2,"w":2,"h":1},{"x":2,"y":3,"w":1,"h":1},{"x":4,"y":4,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":7,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":0,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":3,"y":3,"w":4,"h":1,"shape":"1x4"},{"x":2,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":4,"y":5,"w":4,"h":3,"shape":"3x4"}]},
  {"level":10,"board":8,"difficulty":"easy","fixed_blocks":[{"x":2,"y":0,"w":1,"h":3},{"x":2,"y":3,"w":2,"h":1},{"x":1,"y":7,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":3,"w":1,"h":4,"shape":"1x4"},{"x":4,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":2,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":4,"y":5,"w":4,"h":3,"shape":"3x4"}]},
  {"level":11,"board":8,"difficulty":"easy","fixed_blocks":[{"x":2,"y":2,"w":1,"h":3},{"x":5,"y":6,"w":1,"h":2},{"x":7,"y":7,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":6,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":2,"w":3,"h":4,"shape":"3x4"},{"x":6,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":7,"y":3,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":6,"w":2,"h":2,"shape":"2x2"}]},
  {"level":12,"board":8,"difficulty":"easy","fixed_blocks":[{"x":0,"y":0,"w":1,"h":1},{"x":2,"y":0,"w":1,"h":2},{"x":5,"y":3,"w":3,"h":1}],"solution":[{"x":1,"y":0,"w":1,"h":4,"shape":"1x4"},{"x":3,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":1,"w":1,"h":5,"shape":"1x5"},{"x":2,"y":2,"w":3,"h":2,"shape":"2x3"},{"x":1,"y":4,"w":4,"h":2,"shape":"2x4"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":13,"board":8,"difficulty":"easy","fixed_blocks":[{"x":0,"y":1,"w":1,"h":2},{"x":0,"y":5,"w":1,"h":3},{"x":5,"y":6,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":4,"h":1,"shape":"1x4"},{"x":4,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":1,"y":1,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":3,"w":5,"h":2,"shape":"2x5"},{"x":5,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":1,"y":5,"w":4,"h":2,"shape":"2x4"},{"x":6,"y":6,"w":2,"h":2,"shape":"2x2"},{"x":1,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":14,"board":8,"difficulty":"easy","fixed_blocks":[{"x":1,"y":2,"w":1,"h":2},{"x":6,"y":3,"w":1,"h":1},{"x":0,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":0,"w":3,"h":2,"shape":"2x3"},{"x":4,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":7,"y":0,"w":1,"h":4,"shape":"1x4"},{"x":2,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":1,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":6,"y":4,"w":2,"h":4,"shape":"2x4"}]},
  {"level":15,"board":8,"difficulty":"easy","fixed_blocks":[{"x":3,"y":2,"w":1,"h":1},{"x":7,"y":5,"w":1,"h":3},{"x":5,"y":6,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":7,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":4,"y":2,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":3,"w":4,"h":3,"shape":"3x4"},{"x":4,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":6,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":16,"board":8,"difficulty":"easy","fixed_blocks":[{"x":1,"y":3,"w":1,"h":1},{"x":5,"y":4,"w":2,"h":1},{"x":5,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":5,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":7,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":2,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":5,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":17,"board":8,"difficulty":"easy","fixed_blocks":[{"x":3,"y":4,"w":1,"h":2},{"x":0,"y":5,"w":1,"h":3},{"x":3,"y":7,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":2,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":4,"w":4,"h":2,"shape":"2x4"},{"x":1,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":6,"w":5,"h":1,"shape":"1x5"},{"x":4,"y":7,"w":4,"h":1,"shape":"1x4"}]},
  {"level":18,"board":8,"difficulty":"easy","fixed_blocks":[{"x":3,"y":2,"w":1,"h":1},{"x":1,"y":3,"w":1,"h":2},{"x":4,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":4,"y":2,"w":4,"h":2,"shape":"2x4"},{"x":2,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":4,"w":3,"h":3,"shape":"3x3"},{"x":7,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":5,"w":4,"h":3,"shape":"3x4"}]},
  {"level":19,"board":8,"difficulty":"easy","fixed_blocks":[{"x":5,"y":3,"w":2,"h":1},{"x":5,"y":4,"w":1,"h":1},{"x":1,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":5,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":7,"y":0,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":6,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":5,"w":4,"h":3,"shape":"3x4"}]},
  {"level":20,"board":8,"difficulty":"easy","fixed_blocks":[{"x":7,"y":0,"w":1,"h":1},{"x":7,"y":2,"w":1,"h":3},{"x":4,"y":4,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":0,"w":4,"h":1,"shape":"1x4"},{"x":3,"y":1,"w":5,"h":1,"shape":"1x5"},{"x":3,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":2,"w":2,"h":3,"shape":"2x3"},{"x":0,"y":4,"w":4,"h":2,"shape":"2x4"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":21,"board":8,"difficulty":"easy","fixed_blocks":[{"x":7,"y":2,"w":1,"h":3},{"x":4,"y":4,"w":1,"h":2},{"x":4,"y":7,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":3,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":2,"w":2,"h":3,"shape":"2x3"},{"x":0,"y":4,"w":4,"h":2,"shape":"2x4"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":6,"w":5,"h":1,"shape":"1x5"},{"x":0,"y":7,"w":4,"h":1,"shape":"1x4"}]},
  {"level":22,"board":8,"difficulty":"easy","fixed_blocks":[{"x":5,"y":1,"w":1,"h":1},{"x":7,"y":2,"w":1,"h":3},{"x":3,"y":5,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":0,"w":4,"h":1,"shape":"1x4"},{"x":6,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":2,"y":1,"w":3,"h":4,"shape":"3x4"},{"x":5,"y":2,"w":2,"h":3,"shape":"2x3"},{"x":0,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":4,"y":5,"w":4,"h":2,"shape":"2x4"},{"x":3,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":23,"board":8,"difficulty":"easy","fixed_blocks":[{"x":3,"y":2,"w":2,"h":1},{"x":2,"y":3,"w":1,"h":3},{"x":2,"y":6,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":3,"y":3,"w":2,"h":4,"shape":"2x4"},{"x":5,"y":4,"w":2,"h":3,"shape":"2x3"},{"x":7,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":2,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":24,"board":8,"difficulty":"easy","fixed_blocks":[{"x":1,"y":4,"w":2,"h":1},{"x":1,"y":5,"w":1,"h":1},{"x":5,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":2,"w":4,"h":2,"shape":"2x4"},{"x":3,"y":4,"w":5,"h":1,"shape":"1x5"},{"x":2,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":0,"y":6,"w":2,"h":2,"shape":"2x2"}]},
  {"level":25,"board":8,"difficulty":"easy","fixed_blocks":[{"x":7,"y":0,"w":1,"h":3},{"x":3,"y":2,"w":1,"h":1},{"x":7,"y":5,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":0,"w":3,"h":2,"shape":"2x3"},{"x":4,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":1,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":3,"w":5,"h":2,"shape":"2x5"},{"x":0,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":5,"w":4,"h":2,"shape":"2x4"},{"x":3,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":26,"board":8,"difficulty":"easy","fixed_blocks":[{"x":1,"y":3,"w":1,"h":1},{"x":4,"y":4,"w":2,"h":1},{"x":5,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":4,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":2,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":1,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":2,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":5,"y":5,"w":3,"h":2,"shape":"2x3"}]},
  {"level":27,"board":8,"difficulty":"easy","fixed_blocks":[{"x":4,"y":0,"w":3,"h":1},{"x":3,"y":2,"w":1,"h":2},{"x":7,"y":5,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":0,"w":3,"h":2,"shape":"2x3"},{"x":7,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":4,"y":1,"w":3,"h":3,"shape":"3x3"},{"x":1,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":4,"w":4,"h":2,"shape":"2x4"},{"x":3,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":28,"board":8,"difficulty":"easy","fixed_blocks":[{"x":2,"y":0,"w":1,"h":1},{"x":6,"y":0,"w":2,"h":1},{"x":5,"y":3,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":3,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":2,"y":1,"w":1,"h":4,"shape":"1x4"},{"x":6,"y":1,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":3,"w":2,"h":4,"shape":"2x4"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":5,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":29,"board":8,"difficulty":"easy","fixed_blocks":[{"x":2,"y":1,"w":1,"h":3},{"x":3,"y":3,"w":1,"h":1},{"x":0,"y":7,"w":2,"h":1}],"solution":[{"x":0,"y":0,"w":5,"h":1,"shape":"1x5"},{"x":5,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":1,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":1,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":3,"w":2,"h":4,"shape":"2x4"},{"x":6,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":0,"y":4,"w":4,"h":3,"shape":"3x4"},{"x":2,"y":7,"w":4,"h":1,"shape":"1x4"}]},
  {"level":30,"board":8,"difficulty":"easy","fixed_blocks":[{"x":2,"y":2,"w":1,"h":1},{"x":0,"y":3,"w":1,"h":2},{"x":3,"y":4,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":2,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":7,"y":0,"w":1,"h":4,"shape":"1x4"},{"x":3,"y":2,"w":4,"h":2,"shape":"2x4"},{"x":1,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":4,"w":4,"h":3,"shape":"3x4"},{"x":0,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":31,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":2,"w":1,"h":3},{"x":4,"y":4,"w":1,"h":1},{"x":1,"y":7,"w":2,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":4,"y":2,"w":4,"h":2,"shape":"2x4"},{"x":0,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":4,"w":2,"h":3,"shape":"2x3"},{"x":5,"y":4,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":5,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":32,"board":8,"difficulty":"medium","fixed_blocks":[{"x":0,"y":2,"w":1,"h":2},{"x":4,"y":2,"w":1,"h":1},{"x":5,"y":3,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":5,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":1,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":4,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":0,"y":4,"w":3,"h":2,"shape":"2x3"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":6,"w":4,"h":2,"shape":"2x4"}]},
  {"level":33,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":2,"w":1,"h":2},{"x":2,"y":3,"w":1,"h":3},{"x":4,"y":7,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":4,"y":2,"w":4,"h":2,"shape":"2x4"},{"x":0,"y":3,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":6,"w":5,"h":1,"shape":"1x5"},{"x":0,"y":7,"w":4,"h":1,"shape":"1x4"}]},
  {"level":34,"board":8,"difficulty":"medium","fixed_blocks":[{"x":2,"y":2,"w":1,"h":1},{"x":4,"y":3,"w":1,"h":3},{"x":1,"y":7,"w":2,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":2,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":3,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":3,"w":2,"h":4,"shape":"2x4"},{"x":5,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":35,"board":8,"difficulty":"medium","fixed_blocks":[{"x":2,"y":0,"w":1,"h":2},{"x":3,"y":5,"w":1,"h":1},{"x":5,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":4,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":0,"y":2,"w":3,"h":4,"shape":"3x4"},{"x":4,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":5,"y":2,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":0,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":36,"board":8,"difficulty":"medium","fixed_blocks":[{"x":4,"y":2,"w":1,"h":3},{"x":7,"y":2,"w":1,"h":2},{"x":2,"y":3,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":4,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":5,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":5,"w":2,"h":3,"shape":"2x3"}]},
  {"level":37,"board":8,"difficulty":"medium","fixed_blocks":[{"x":4,"y":0,"w":1,"h":3},{"x":5,"y":0,"w":1,"h":2},{"x":7,"y":5,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":6,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":2,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":3,"w":4,"h":2,"shape":"2x4"},{"x":1,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":5,"w":4,"h":1,"shape":"1x4"},{"x":3,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":38,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":0,"w":2,"h":1},{"x":1,"y":3,"w":1,"h":1},{"x":2,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":5,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":1,"w":2,"h":2,"shape":"2x2"},{"x":2,"y":3,"w":5,"h":2,"shape":"2x5"},{"x":7,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":0,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":3,"y":5,"w":4,"h":3,"shape":"3x4"}]},
  {"level":39,"board":8,"difficulty":"medium","fixed_blocks":[{"x":4,"y":2,"w":1,"h":3},{"x":7,"y":2,"w":1,"h":2},{"x":2,"y":7,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":4,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":5,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":3,"w":1,"h":4,"shape":"1x4"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":5,"w":2,"h":3,"shape":"2x3"}]},
  {"level":40,"board":8,"difficulty":"medium","fixed_blocks":[{"x":4,"y":2,"w":1,"h":2},{"x":2,"y":4,"w":1,"h":3},{"x":3,"y":4,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":2,"w":4,"h":2,"shape":"2x4"},{"x":0,"y":4,"w":2,"h":3,"shape":"2x3"},{"x":4,"y":4,"w":4,"h":1,"shape":"1x4"},{"x":3,"y":5,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":41,"board":8,"difficulty":"medium","fixed_blocks":[{"x":0,"y":4,"w":3,"h":1},{"x":6,"y":4,"w":1,"h":1},{"x":4,"y":6,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":3,"y":2,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":7,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":5,"w":5,"h":1,"shape":"1x5"},{"x":5,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":0,"y":6,"w":4,"h":2,"shape":"2x4"}]},
  {"level":42,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":0,"w":1,"h":1},{"x":0,"y":2,"w":2,"h":1},{"x":5,"y":3,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":2,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":4,"y":0,"w":4,"h":1,"shape":"1x4"},{"x":3,"y":1,"w":2,"h":4,"shape":"2x4"},{"x":5,"y":1,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":2,"y":5,"w":3,"h":3,"shape":"3x3"}]},
  {"level":43,"board":8,"difficulty":"medium","fixed_blocks":[{"x":1,"y":3,"w":1,"h":3},{"x":1,"y":6,"w":1,"h":2},{"x":4,"y":3,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":2,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":4,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":5,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":2,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":3,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":44,"board":8,"difficulty":"medium","fixed_blocks":[{"x":5,"y":2,"w":1,"h":1},{"x":1,"y":3,"w":1,"h":3},{"x":1,"y":6,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":4,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":6,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":4,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":2,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":5,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":4,"y":6,"w":4,"h":2,"shape":"2x4"}]},
  {"level":45,"board":8,"difficulty":"medium","fixed_blocks":[{"x":4,"y":2,"w":2,"h":1},{"x":1,"y":4,"w":1,"h":1},{"x":5,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":4,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":6,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":4,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":5,"y":3,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":5,"w":3,"h":3,"shape":"3x3"}]},
  {"level":46,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":0,"w":1,"h":2},{"x":4,"y":2,"w":1,"h":3},{"x":5,"y":2,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":2,"shape":"2x3"},{"x":4,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":0,"y":2,"w":4,"h":3,"shape":"3x4"},{"x":6,"y":2,"w":2,"h":5,"shape":"2x5"},{"x":5,"y":3,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":5,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":47,"board":8,"difficulty":"medium","fixed_blocks":[{"x":4,"y":0,"w":2,"h":1},{"x":3,"y":3,"w":1,"h":1},{"x":2,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":4,"y":1,"w":2,"h":4,"shape":"2x4"},{"x":1,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":4,"y":5,"w":4,"h":3,"shape":"3x4"}]},
  {"level":48,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":0,"w":3,"h":1},{"x":3,"y":1,"w":1,"h":1},{"x":3,"y":4,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":3,"h":2,"shape":"2x3"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":4,"y":1,"w":1,"h":5,"shape":"1x5"},{"x":5,"y":1,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":2,"w":4,"h":2,"shape":"2x4"},{"x":0,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":6,"w":2,"h":2,"shape":"2x2"}]},
  {"level":49,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":3,"w":1,"h":1},{"x":0,"y":5,"w":1,"h":3},{"x":4,"y":6,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":3,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":4,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":1,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":4,"y":5,"w":4,"h":1,"shape":"1x4"},{"x":5,"y":6,"w":3,"h":2,"shape":"2x3"}]},
  {"level":50,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":0,"w":3,"h":1},{"x":3,"y":1,"w":1,"h":1},{"x":2,"y":4,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":6,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":4,"y":1,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":4,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":7,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":0,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":51,"board":8,"difficulty":"medium","fixed_blocks":[{"x":0,"y":0,"w":1,"h":1},{"x":7,"y":4,"w":1,"h":2},{"x":3,"y":5,"w":1,"h":3}],"solution":[{"x":1,"y":0,"w":4,"h":1,"shape":"1x4"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":1,"w":5,"h":2,"shape":"2x5"},{"x":0,"y":3,"w":4,"h":2,"shape":"2x4"},{"x":4,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":5,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":5,"y":6,"w":3,"h":2,"shape":"2x3"}]},
  {"level":52,"board":8,"difficulty":"medium","fixed_blocks":[{"x":2,"y":3,"w":1,"h":3},{"x":3,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":4,"h":1,"shape":"1x4"},{"x":4,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":0,"y":1,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":1,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":3,"w":5,"h":1,"shape":"1x5"},{"x":3,"y":4,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":0,"y":6,"w":3,"h":2,"shape":"2x3"}]},
  {"level":53,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":2,"w":1,"h":1},{"x":7,"y":3,"w":1,"h":3},{"x":0,"y":4,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":4,"y":2,"w":4,"h":1,"shape":"1x4"},{"x":3,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":4,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":1,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":6,"w":3,"h":2,"shape":"2x3"},{"x":4,"y":6,"w":4,"h":2,"shape":"2x4"}]},
  {"level":54,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":0,"w":3,"h":1},{"x":3,"y":3,"w":1,"h":1},{"x":4,"y":6,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":3,"y":1,"w":3,"h":2,"shape":"2x3"},{"x":4,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":4,"w":4,"h":1,"shape":"1x4"},{"x":0,"y":5,"w":5,"h":1,"shape":"1x5"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":6,"w":4,"h":2,"shape":"2x4"}]},
  {"level":55,"board":8,"difficulty":"medium","fixed_blocks":[{"x":3,"y":2,"w":1,"h":2},{"x":0,"y":3,"w":3,"h":1},{"x":2,"y":4,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":4,"y":2,"w":4,"h":2,"shape":"2x4"},{"x":0,"y":4,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":4,"w":5,"h":1,"shape":"1x5"},{"x":2,"y":5,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":5,"w":4,"h":3,"shape":"3x4"},{"x":0,"y":7,"w":4,"h":1,"shape":"1x4"}]},
  {"level":56,"board":8,"difficulty":"medium","fixed_blocks":[{"x":4,"y":0,"w":1,"h":3},{"x":3,"y":5,"w":1,"h":1},{"x":4,"y":7,"w":2,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":5,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":4,"y":3,"w":2,"h":4,"shape":"2x4"},{"x":6,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":0,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":1,"y":6,"w":3,"h":2,"shape":"2x3"}]},
  {"level":57,"board":8,"difficulty":"medium","fixed_blocks":[{"x":7,"y":4,"w":1,"h":2},{"x":4,"y":6,"w":1,"h":1},{"x":2,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":4,"y":0,"w":4,"h":1,"shape":"1x4"},{"x":4,"y":1,"w":1,"h":5,"shape":"1x5"},{"x":5,"y":1,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":3,"w":2,"h":4,"shape":"2x4"},{"x":5,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":6,"w":3,"h":2,"shape":"2x3"}]},
  {"level":58,"board":8,"difficulty":"medium","fixed_blocks":[{"x":4,"y":2,"w":1,"h":1},{"x":0,"y":4,"w":1,"h":2},{"x":3,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":2,"w":4,"h":1,"shape":"1x4"},{"x":0,"y":3,"w":5,"h":1,"shape":"1x5"},{"x":1,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":4,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":0,"y":6,"w":3,"h":2,"shape":"2x3"}]},
  {"level":59,"board":8,"difficulty":"medium","fixed_blocks":[{"x":0,"y":3,"w":2,"h":1},{"x":3,"y":6,"w":1,"h":1},{"x":3,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":3,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":4,"y":2,"w":4,"h":3,"shape":"3x4"},{"x":2,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":0,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":4,"y":5,"w":2,"h":2,"shape":"2x2"},{"x":6,"y":5,"w":2,"h":3,"shape":"2x3"}]},
  {"level":60,"board":8,"difficulty":"medium","fixed_blocks":[{"x":5,"y":2,"w":1,"h":1},{"x":2,"y":4,"w":2,"h":1},{"x":0,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":5,"y":0,"w":3,"h":2,"shape":"2x3"},{"x":6,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":2,"y":3,"w":4,"h":1,"shape":"1x4"},{"x":4,"y":4,"w":4,"h":3,"shape":"3x4"},{"x":0,"y":5,"w":4,"h":2,"shape":"2x4"},{"x":3,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":61,"board":8,"difficulty":"hard","fixed_blocks":[{"x":0,"y":2,"w":2,"h":1},{"x":5,"y":3,"w":1,"h":1},{"x":2,"y":5,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":2,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":0,"y":3,"w":5,"h":1,"shape":"1x5"},{"x":0,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":4,"w":4,"h":1,"shape":"1x4"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":2,"y":6,"w":3,"h":2,"shape":"2x3"}]},
  {"level":62,"board":8,"difficulty":"hard","fixed_blocks":[{"x":2,"y":2,"w":1,"h":1},{"x":5,"y":3,"w":3,"h":1},{"x":0,"y":4,"w":2,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":0,"w":3,"h":2,"shape":"2x3"},{"x":5,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":2,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":3,"w":1,"h":4,"shape":"1x4"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":5,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":63,"board":8,"difficulty":"hard","fixed_blocks":[{"x":3,"y":2,"w":1,"h":2},{"x":2,"y":3,"w":1,"h":1},{"x":4,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":4,"y":2,"w":4,"h":2,"shape":"2x4"},{"x":0,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":2,"y":4,"w":5,"h":1,"shape":"1x5"},{"x":7,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":5,"w":4,"h":3,"shape":"3x4"},{"x":5,"y":5,"w":2,"h":3,"shape":"2x3"}]},
  {"level":64,"board":8,"difficulty":"hard","fixed_blocks":[{"x":3,"y":2,"w":2,"h":1},{"x":5,"y":3,"w":1,"h":1},{"x":0,"y":4,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":3,"w":2,"h":4,"shape":"2x4"},{"x":6,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":5,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":5,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":65,"board":8,"difficulty":"hard","fixed_blocks":[{"x":2,"y":3,"w":2,"h":1},{"x":3,"y":4,"w":1,"h":3},{"x":4,"y":6,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":4,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":4,"w":3,"h":3,"shape":"3x3"},{"x":4,"y":5,"w":4,"h":1,"shape":"1x4"},{"x":5,"y":6,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":7,"w":5,"h":1,"shape":"1x5"}]},
  {"level":66,"board":8,"difficulty":"hard","fixed_blocks":[{"x":4,"y":0,"w":2,"h":1},{"x":3,"y":3,"w":1,"h":1},{"x":2,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":6,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":4,"y":1,"w":2,"h":3,"shape":"2x3"},{"x":0,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":3,"w":1,"h":4,"shape":"1x4"},{"x":3,"y":4,"w":5,"h":1,"shape":"1x5"},{"x":3,"y":5,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"}]},
  {"level":67,"board":8,"difficulty":"hard","fixed_blocks":[{"x":0,"y":0,"w":1,"h":3},{"x":6,"y":3,"w":2,"h":1},{"x":2,"y":5,"w":1,"h":1}],"solution":[{"x":1,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":6,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":1,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":2,"y":2,"w":4,"h":3,"shape":"3x4"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":6,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":3,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":1,"y":6,"w":2,"h":2,"shape":"2x2"}]},
  {"level":68,"board":8,"difficulty":"hard","fixed_blocks":[{"x":0,"y":2,"w":1,"h":3},{"x":5,"y":4,"w":1,"h":1},{"x":2,"y":6,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":4,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":1,"y":2,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":4,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":2,"y":5,"w":4,"h":1,"shape":"1x4"},{"x":3,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":69,"board":8,"difficulty":"hard","fixed_blocks":[{"x":0,"y":2,"w":1,"h":3},{"x":4,"y":3,"w":1,"h":1},{"x":2,"y":6,"w":1,"h":2}],"solution":[{"x":0,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":4,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":1,"y":2,"w":3,"h":2,"shape":"2x3"},{"x":5,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":1,"y":4,"w":4,"h":1,"shape":"1x4"},{"x":0,"y":5,"w":5,"h":1,"shape":"1x5"},{"x":0,"y":6,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":70,"board":8,"difficulty":"hard","fixed_blocks":[{"x":2,"y":0,"w":1,"h":2},{"x":0,"y":5,"w":1,"h":3},{"x":4,"y":5,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":0,"w":1,"h":4,"shape":"1x4"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":2,"y":2,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":2,"w":4,"h":3,"shape":"3x4"},{"x":1,"y":4,"w":3,"h":2,"shape":"2x3"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":1,"y":6,"w":4,"h":2,"shape":"2x4"}]},
  {"level":71,"board":8,"difficulty":"hard","fixed_blocks":[{"x":5,"y":2,"w":1,"h":2},{"x":0,"y":5,"w":1,"h":3},{"x":3,"y":5,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":6,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":1,"y":2,"w":3,"h":3,"shape":"3x3"},{"x":4,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":1,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":3,"y":6,"w":2,"h":2,"shape":"2x2"}]},
  {"level":72,"board":8,"difficulty":"hard","fixed_blocks":[{"x":0,"y":0,"w":1,"h":3},{"x":3,"y":3,"w":1,"h":1},{"x":2,"y":7,"w":2,"h":1}],"solution":[{"x":1,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":3,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":0,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":4,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":1,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":2,"y":4,"w":2,"h":3,"shape":"2x3"},{"x":4,"y":5,"w":4,"h":3,"shape":"3x4"}]},
  {"level":73,"board":8,"difficulty":"hard","fixed_blocks":[{"x":2,"y":2,"w":1,"h":3},{"x":0,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":3,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":4,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":7,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":0,"y":5,"w":3,"h":2,"shape":"2x3"},{"x":3,"y":6,"w":4,"h":2,"shape":"2x4"}]},
  {"level":74,"board":8,"difficulty":"hard","fixed_blocks":[{"x":3,"y":3,"w":1,"h":2},{"x":2,"y":6,"w":1,"h":1},{"x":0,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":4,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":4,"y":2,"w":3,"h":3,"shape":"3x3"},{"x":7,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":3,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":5,"w":2,"h":2,"shape":"2x2"},{"x":2,"y":5,"w":5,"h":1,"shape":"1x5"},{"x":3,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":75,"board":8,"difficulty":"hard","fixed_blocks":[{"x":0,"y":0,"w":1,"h":3},{"x":1,"y":2,"w":1,"h":1},{"x":3,"y":7,"w":2,"h":1}],"solution":[{"x":1,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":2,"y":2,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":3,"y":4,"w":5,"h":1,"shape":"1x5"},{"x":3,"y":5,"w":2,"h":2,"shape":"2x2"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"}]},
  {"level":76,"board":8,"difficulty":"hard","fixed_blocks":[{"x":5,"y":0,"w":1,"h":2},{"x":2,"y":2,"w":1,"h":1},{"x":3,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":0,"w":3,"h":2,"shape":"2x3"},{"x":6,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":2,"w":5,"h":1,"shape":"1x5"},{"x":2,"y":3,"w":4,"h":1,"shape":"1x4"},{"x":6,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":0,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":4,"w":3,"h":3,"shape":"3x3"}]},
  {"level":77,"board":8,"difficulty":"hard","fixed_blocks":[{"x":3,"y":3,"w":1,"h":1},{"x":0,"y":4,"w":2,"h":1},{"x":0,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":3,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":4,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":1,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":4,"y":5,"w":4,"h":3,"shape":"3x4"}]},
  {"level":78,"board":8,"difficulty":"hard","fixed_blocks":[{"x":0,"y":2,"w":1,"h":3},{"x":4,"y":3,"w":1,"h":2},{"x":5,"y":4,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":5,"y":0,"w":3,"h":4,"shape":"3x4"},{"x":1,"y":2,"w":4,"h":1,"shape":"1x4"},{"x":1,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":6,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":0,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":4,"y":5,"w":2,"h":3,"shape":"2x3"}]},
  {"level":79,"board":8,"difficulty":"hard","fixed_blocks":[{"x":7,"y":2,"w":1,"h":3},{"x":3,"y":4,"w":2,"h":1},{"x":3,"y":5,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":3,"y":2,"w":4,"h":1,"shape":"1x4"},{"x":0,"y":3,"w":5,"h":1,"shape":"1x5"},{"x":5,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":4,"w":3,"h":2,"shape":"2x3"},{"x":4,"y":5,"w":4,"h":3,"shape":"3x4"},{"x":0,"y":6,"w":4,"h":2,"shape":"2x4"}]},
  {"level":80,"board":8,"difficulty":"hard","fixed_blocks":[{"x":5,"y":0,"w":3,"h":1},{"x":4,"y":2,"w":1,"h":2},{"x":5,"y":4,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":5,"y":1,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":2,"w":4,"h":2,"shape":"2x4"},{"x":0,"y":4,"w":5,"h":1,"shape":"1x5"},{"x":6,"y":4,"w":2,"h":3,"shape":"2x3"},{"x":0,"y":5,"w":4,"h":3,"shape":"3x4"},{"x":4,"y":5,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":7,"w":4,"h":1,"shape":"1x4"}]},
  {"level":81,"board":8,"difficulty":"hard","fixed_blocks":[{"x":5,"y":0,"w":1,"h":2},{"x":2,"y":2,"w":1,"h":1},{"x":0,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":0,"w":3,"h":2,"shape":"2x3"},{"x":6,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":2,"w":5,"h":1,"shape":"1x5"},{"x":2,"y":3,"w":4,"h":1,"shape":"1x4"},{"x":6,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":0,"y":4,"w":3,"h":3,"shape":"3x3"},{"x":3,"y":4,"w":3,"h":4,"shape":"3x4"}]},
  {"level":82,"board":8,"difficulty":"hard","fixed_blocks":[{"x":7,"y":2,"w":1,"h":3},{"x":2,"y":3,"w":2,"h":1},{"x":4,"y":5,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":4,"y":0,"w":4,"h":2,"shape":"2x4"},{"x":4,"y":2,"w":3,"h":2,"shape":"2x3"},{"x":0,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":2,"y":4,"w":5,"h":1,"shape":"1x5"},{"x":0,"y":5,"w":4,"h":1,"shape":"1x4"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":83,"board":8,"difficulty":"hard","fixed_blocks":[{"x":5,"y":0,"w":1,"h":2},{"x":3,"y":3,"w":1,"h":1},{"x":2,"y":7,"w":3,"h":1}],"solution":[{"x":0,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":6,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":0,"y":2,"w":3,"h":2,"shape":"2x3"},{"x":3,"y":2,"w":5,"h":1,"shape":"1x5"},{"x":4,"y":3,"w":4,"h":1,"shape":"1x4"},{"x":0,"y":4,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":4,"w":3,"h":3,"shape":"3x3"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"}]},
  {"level":84,"board":8,"difficulty":"hard","fixed_blocks":[{"x":4,"y":0,"w":2,"h":1},{"x":5,"y":1,"w":1,"h":3},{"x":2,"y":2,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":2,"y":0,"w":2,"h":2,"shape":"2x2"},{"x":6,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":4,"y":1,"w":1,"h":5,"shape":"1x5"},{"x":3,"y":2,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":3,"w":3,"h":3,"shape":"3x3"},{"x":5,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":0,"y":6,"w":5,"h":2,"shape":"2x5"}]},
  {"level":85,"board":8,"difficulty":"hard","fixed_blocks":[{"x":5,"y":2,"w":1,"h":1},{"x":3,"y":3,"w":1,"h":2},{"x":4,"y":5,"w":1,"h":3}],"solution":[{"x":0,"y":0,"w":1,"h":5,"shape":"1x5"},{"x":1,"y":0,"w":5,"h":2,"shape":"2x5"},{"x":6,"y":0,"w":2,"h":3,"shape":"2x3"},{"x":1,"y":2,"w":4,"h":1,"shape":"1x4"},{"x":1,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":4,"y":3,"w":4,"h":2,"shape":"2x4"},{"x":0,"y":5,"w":4,"h":3,"shape":"3x4"},{"x":5,"y":5,"w":3,"h":3,"shape":"3x3"}]},
  {"level":86,"board":8,"difficulty":"hard","fixed_blocks":[{"x":7,"y":3,"w":1,"h":3},{"x":5,"y":5,"w":2,"h":1},{"x":2,"y":4,"w":1,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":4,"y":0,"w":4,"h":3,"shape":"3x4"},{"x":4,"y":3,"w":1,"h":5,"shape":"1x5"},{"x":5,"y":3,"w":2,"h":2,"shape":"2x2"},{"x":3,"y":4,"w":1,"h":4,"shape":"1x4"},{"x":0,"y":5,"w":3,"h":3,"shape":"3x3"},{"x":5,"y":6,"w":3,"h":2,"shape":"2x3"}]},
  {"level":87,"board":8,"difficulty":"hard","fixed_blocks":[{"x":4,"y":0,"w":1,"h":3},{"x":2,"y":5,"w":1,"h":1},{"x":6,"y":7,"w":2,"h":1}],"solution":[{"x":0,"y":0,"w":4,"h":1,"shape":"1x4"},{"x":5,"y":0,"w":3,"h":3,"shape":"3x3"},{"x":0,"y":1,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":1,"w":1,"h":5,"shape":"1x5"},{"x":4,"y":3,"w":2,"h":5,"shape":"2x5"},{"x":6,"y":3,"w":2,"h":4,"shape":"2x4"},{"x":0,"y":5,"w":2,"h":3,"shape":"2x3"},{"x":2,"y":6,"w":2,"h":2,"shape":"2x2"}]},
  {"level":88,"board":8,"difficulty":"hard","fixed_blocks":[{"x":6,"y":5,"w":1,"h":1},{"x":7,"y":5,"w":1,"h":3},{"x":3,"y":7,"w":2,"h":1}],"solution":[{"x":0,"y":0,"w":2,"h":4,"shape":"2x4"},{"x":2,"y":0,"w":4,"h":1,"shape":"1x4"},{"x":6,"y":0,"w":2,"h":5,"shape":"2x5"},{"x":2,"y":1,"w":3,"h":3,"shape":"3x3"},{"x":5,"y":1,"w":1,"h":5,"shape":"1x5"},{"x":0,"y":4,"w":3,"h":4,"shape":"3x4"},{"x":3,"y":4,"w":2,"h":3,"shape":"2x3"},{"x":5,"y":6,"w":2,"h":2,"shape":"2x2"}]}
]
};

// Piece set -- identical across every level, matches Android MOVABLE_PIECES.
const MOVABLE_PIECES = [
  { id: 1, baseW: 1, baseH: 4 },
  { id: 2, baseW: 1, baseH: 5 },
  { id: 3, baseW: 2, baseH: 2 },
  { id: 4, baseW: 2, baseH: 3 },
  { id: 5, baseW: 2, baseH: 4 },
  { id: 6, baseW: 2, baseH: 5 },
  { id: 7, baseW: 3, baseH: 3 },
  { id: 8, baseW: 3, baseH: 4 },
];

const PIECE_COLORS = [
  '#F29B9B', // coral
  '#8FD4C7', // seafoam
  '#DDA0CF', // orchid
  '#8FB7E8', // periwinkle
  '#C7AEF0', // lavender
  '#B9A08C', // taupe
  '#F0C889', // apricot
  '#9CC9A1', // sage
];

const FIXED_BLOCK_COLOR = '#3A362F';

function pieceColor(pieceId) {
  return PIECE_COLORS[(pieceId - 1) % PIECE_COLORS.length];
}

/** Mirrors GameEngine.kt exactly -- same rules, same hint logic, so a level
 * that's solvable/hintable in the Android app behaves identically here. */
class GameEngine {
  constructor(level) {
    this.level = level;
    this.boardSize = level.board;
    this.grid = Array.from({ length: this.boardSize }, () => new Array(this.boardSize).fill(0));
    this.pieces = MOVABLE_PIECES.map((p) => ({ piece: p, placed: false, rotated: false, x: -1, y: -1 }));
    for (const b of level.fixed_blocks) {
      for (let y = b.y; y < b.y + b.h; y++) {
        for (let x = b.x; x < b.x + b.w; x++) {
          this.grid[y][x] = -1;
        }
      }
    }
  }

  width(piece, rotated) {
    return rotated ? piece.baseH : piece.baseW;
  }
  height(piece, rotated) {
    return rotated ? piece.baseW : piece.baseH;
  }

  canPlace(pp, x, y, rotated) {
    const w = this.width(pp.piece, rotated);
    const h = this.height(pp.piece, rotated);
    if (x < 0 || y < 0 || x + w > this.boardSize || y + h > this.boardSize) return false;
    for (let yy = y; yy < y + h; yy++) {
      for (let xx = x; xx < x + w; xx++) {
        if (this.grid[yy][xx] !== 0) return false;
      }
    }
    return true;
  }

  place(pp, x, y, rotated) {
    if (!this.canPlace(pp, x, y, rotated)) return false;
    const w = this.width(pp.piece, rotated);
    const h = this.height(pp.piece, rotated);
    for (let yy = y; yy < y + h; yy++) {
      for (let xx = x; xx < x + w; xx++) {
        this.grid[yy][xx] = pp.piece.id;
      }
    }
    pp.placed = true;
    pp.rotated = rotated;
    pp.x = x;
    pp.y = y;
    return true;
  }

  removeFromGrid(pp) {
    if (!pp.placed) return;
    const w = this.width(pp.piece, pp.rotated);
    const h = this.height(pp.piece, pp.rotated);
    for (let yy = pp.y; yy < pp.y + h; yy++) {
      for (let xx = pp.x; xx < pp.x + w; xx++) {
        this.grid[yy][xx] = 0;
      }
    }
    pp.placed = false;
    pp.x = -1;
    pp.y = -1;
  }

  pieceAt(x, y) {
    if (y < 0 || y >= this.boardSize || x < 0 || x >= this.boardSize) return null;
    const id = this.grid[y][x];
    if (id <= 0) return null;
    return this.pieces.find((p) => p.piece.id === id) || null;
  }

  isFixedAt(x, y) {
    return this.grid[y]?.[x] === -1;
  }

  isComplete() {
    return this.grid.every((row) => row.every((c) => c !== 0));
  }

  resetAll() {
    for (const p of this.pieces) this.removeFromGrid(p);
  }

  solutionFor(pp) {
    const target = [pp.piece.baseW, pp.piece.baseH].sort().join('x');
    return this.level.solution.find((s) => [s.w, s.h].sort().join('x') === target) || null;
  }

  isCorrectlyPlaced(pp) {
    if (!pp.placed) return false;
    const sol = this.solutionFor(pp);
    if (!sol) return false;
    const w = this.width(pp.piece, pp.rotated);
    const h = this.height(pp.piece, pp.rotated);
    return pp.x === sol.x && pp.y === sol.y && w === sol.w && h === sol.h;
  }

  applyHint() {
    const candidate = this.pieces.find((p) => !this.isCorrectlyPlaced(p));
    if (!candidate) return null;
    const sol = this.solutionFor(candidate);
    if (!sol) return null;
    const rotated = sol.w !== candidate.piece.baseW;
    for (let yy = sol.y; yy < sol.y + sol.h; yy++) {
      for (let xx = sol.x; xx < sol.x + sol.w; xx++) {
        if (yy < 0 || yy >= this.boardSize || xx < 0 || xx >= this.boardSize) continue;
        const occId = this.grid[yy][xx];
        if (occId > 0) {
          const occupant = this.pieces.find((p) => p.piece.id === occId);
          if (occupant) this.removeFromGrid(occupant);
        }
      }
    }
    if (candidate.placed) this.removeFromGrid(candidate);
    this.place(candidate, sol.x, sol.y, rotated);
    return candidate;
  }

  applyFullSolution() {
    for (const p of this.pieces) {
      const sol = this.solutionFor(p);
      if (!sol) continue;
      const rotated = sol.w !== p.piece.baseW;
      if (p.placed) this.removeFromGrid(p);
      this.place(p, sol.x, sol.y, rotated);
    }
  }
}


// ---- Safe storage ----
// Every read/write goes through here. If localStorage is blocked, full, or
// unavailable (private mode, in-app browsers), the game keeps working for the
// session from memory instead of throwing in the middle of a win.
const SafeStorage = {
  mem: {},
  get(key) {
    try {
      const v = window.localStorage.getItem(key);
      if (v !== null) return v;
    } catch (_) {}
    return Object.prototype.hasOwnProperty.call(this.mem, key) ? this.mem[key] : null;
  },
  set(key, value) {
    const s = String(value);
    this.mem[key] = s;
    try {
      window.localStorage.setItem(key, s);
    } catch (_) {}
  },
};

function readJSON(key, fallback) {
  try {
    const raw = SafeStorage.get(key);
    if (raw === null) return fallback;
    const parsed = JSON.parse(raw);
    return parsed === null ? fallback : parsed;
  } catch (_) {
    return fallback;
  }
}

// ---- Progress (which levels are completed) ----
const ProgressStore = {
  KEY: 'thinkly_completed_levels',
  getCompleted() {
    const arr = readJSON(this.KEY, []);
    return new Set(Array.isArray(arr) ? arr : []);
  },
  markCompleted(level) {
    const s = this.getCompleted();
    s.add(level);
    SafeStorage.set(this.KEY, JSON.stringify([...s]));
  },
};

// ---- Solve analytics ----
const AnalyticsStore = {
  KEY: 'thinkly_solves',
  MAX_ENTRIES: 500,
  getAll() {
    const arr = readJSON(this.KEY, []);
    return Array.isArray(arr) ? arr : [];
  },
  recordSolve({ level, difficulty, attempts, timeMs, hintsUsed, returnsUsed }) {
    const all = this.getAll();
    all.push({ level, difficulty, attempts, timeMs, timestamp: Date.now(), hintsUsed, returnsUsed });
    SafeStorage.set(this.KEY, JSON.stringify(all.slice(-this.MAX_ENTRIES)));
  },
  getMostRecentForLevel(level) {
    const matches = this.getAll().filter((s) => s.level === level);
    if (matches.length === 0) return null;
    return matches.reduce((a, b) => (a.timestamp > b.timestamp ? a : b));
  },
  getSummary() {
    const solves = this.getAll();
    if (solves.length === 0) {
      return { totalPlays: 0, totalAttempts: 0, avgTimeMs: 0, fastestSolveMs: null, totalHints: 0, totalReturns: 0 };
    }
    const totalAttempts = solves.reduce((s, x) => s + x.attempts, 0);
    const totalTime = solves.reduce((s, x) => s + x.timeMs, 0);
    const fastest = Math.min(...solves.map((x) => x.timeMs));
    const totalHints = solves.reduce((s, x) => s + (x.hintsUsed || 0), 0);
    const totalReturns = solves.reduce((s, x) => s + (x.returnsUsed || 0), 0);
    return {
      totalPlays: solves.length,
      totalAttempts,
      avgTimeMs: Math.round(totalTime / solves.length),
      fastestSolveMs: fastest,
      totalHints,
      totalReturns,
    };
  },
};

// ---- Daily streak ----
const StreakStore = {
  KEY: 'thinkly_streak',
  // Day index from the local calendar date (via UTC) so DST changes can never
  // make two consecutive days look two days apart.
  todayDayIndex() {
    const d = new Date();
    return Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000);
  },
  read() {
    const obj = readJSON(this.KEY, {});
    return obj && typeof obj === 'object' ? obj : {};
  },
  recordPlayToday() {
    const today = this.todayDayIndex();
    const data = this.read();
    const lastDay = data.lastDay ?? -1;
    let streak = data.streak || 0;
    if (lastDay === today) {
      // already counted today
    } else if (lastDay === today - 1) {
      streak += 1;
    } else {
      streak = 1;
    }
    const longest = Math.max(data.longest || 0, streak);
    SafeStorage.set(this.KEY, JSON.stringify({ lastDay: today, streak, longest }));
    return streak;
  },
  getCurrent() {
    const today = this.todayDayIndex();
    const data = this.read();
    const lastDay = data.lastDay ?? -1;
    if (lastDay === today || lastDay === today - 1) return data.streak || 0;
    return 0;
  },
  getLongest() {
    return this.read().longest || 0;
  },
};

// ---- Achievements ----
const ALL_ACHIEVEMENTS = [
  { id: 'first_solve', title: 'First Steps', description: 'Solve your first puzzle' },
  { id: 'one_attempt', title: 'Perfectionist', description: 'Solve a puzzle on your first attempt' },
  { id: 'speed_60', title: 'Speed Runner', description: 'Solve a puzzle in under a minute' },
  { id: 'no_hints_10', title: 'Independent Thinker', description: 'Solve 10 puzzles without a hint' },
  { id: 'halfway', title: 'Halfway There', description: 'Complete 44 levels' },
  { id: 'puzzle_master', title: 'Puzzle Master', description: 'Complete all 88 levels' },
  { id: 'streak_3', title: 'Getting Warmed Up', description: '3-day play streak' },
  { id: 'streak_7', title: 'One Week Strong', description: '7-day play streak' },
  { id: 'streak_30', title: 'Habit Formed', description: '30-day play streak' },
];

const AchievementsStore = {
  KEY: 'thinkly_achievements',
  NO_HINT_COUNT_KEY: 'thinkly_no_hint_solve_count',
  getUnlocked() {
    const arr = readJSON(this.KEY, []);
    return new Set(Array.isArray(arr) ? arr : []);
  },
  // totalSolved = number of UNIQUE levels completed (re-solving a level
  // never counts twice). firstCompletion = this solve completed the level
  // for the first time.
  checkAfterSolve({ totalSolved, hintsUsedThisLevel, attemptsThisLevel, solveTimeMs, currentStreak, firstCompletion }) {
    const unlocked = this.getUnlocked();
    const newly = [];
    const tryUnlock = (id) => {
      if (!unlocked.has(id)) {
        unlocked.add(id);
        const a = ALL_ACHIEVEMENTS.find((x) => x.id === id);
        if (a) newly.push(a);
      }
    };
    if (totalSolved >= 1) tryUnlock('first_solve');
    if (totalSolved >= 44) tryUnlock('halfway');
    if (totalSolved >= 88) tryUnlock('puzzle_master');
    if (attemptsThisLevel === 1) tryUnlock('one_attempt');
    if (solveTimeMs < 60000) tryUnlock('speed_60');
    if (currentStreak >= 3) tryUnlock('streak_3');
    if (currentStreak >= 7) tryUnlock('streak_7');
    if (currentStreak >= 30) tryUnlock('streak_30');
    if (firstCompletion && hintsUsedThisLevel === 0) {
      const count = (parseInt(SafeStorage.get(this.NO_HINT_COUNT_KEY) || '0', 10) || 0) + 1;
      SafeStorage.set(this.NO_HINT_COUNT_KEY, String(count));
      if (count >= 10) tryUnlock('no_hints_10');
    }
    SafeStorage.set(this.KEY, JSON.stringify([...unlocked]));
    return newly;
  },
};

// ---- Cognitive skills report (gamified estimate, not a medical measurement) ----
const CognitiveReport = {
  compute() {
    const solves = AnalyticsStore.getAll();
    if (solves.length < 3) return [];
    const avgAttempts = solves.reduce((s, x) => s + x.attempts, 0) / solves.length;
    const firstTryRate = solves.filter((x) => x.attempts === 1).length / solves.length;
    const noHintRate = solves.filter((x) => (x.hintsUsed || 0) === 0).length / solves.length;
    const hardSolves = solves.filter((x) => x.difficulty === 'hard').length;
    const longestStreak = StreakStore.getLongest();

    const sorted = [...solves].sort((a, b) => a.timestamp - b.timestamp);
    let improvementPct = 0;
    if (sorted.length >= 6) {
      const firstFew = sorted.slice(0, 3).reduce((s, x) => s + x.timeMs, 0) / 3;
      const lastFew = sorted.slice(-3).reduce((s, x) => s + x.timeMs, 0) / 3;
      if (firstFew > 0) improvementPct = ((firstFew - lastFew) / firstFew) * 100;
    }

    const clamp = (v) => Math.round(Math.min(97, Math.max(15, v)));

    return [
      {
        name: 'Spatial reasoning',
        score: clamp(100 - (avgAttempts - 1) * 22),
        description: 'Visualizing how shapes fit together and rotate in space — exercised every time you place or rotate a block.',
      },
      {
        name: 'Logical planning',
        score: clamp(firstTryRate * 55 + noHintRate * 45),
        description: 'Thinking several moves ahead before committing — reflected in solving with fewer attempts and hints.',
      },
      {
        name: 'Persistence',
        score: clamp(Math.min(longestStreak, 30) * 2 + Math.min(hardSolves, 20) * 2.5),
        description: 'Sticking with a hard problem over time — built by your play streak and steady progress into harder levels.',
      },
      {
        name: 'Adaptability',
        score: clamp(55 + improvementPct * 0.9),
        description: 'Learning from earlier attempts and getting faster with practice.',
      },
    ];
  },
};


// Low-latency sound effects using Web Audio API, mirroring SoundPlayer.kt on
// Android (soft tick for pickup/rotate, a two-tone pop for placement, a
// short chime for solving). All calls are defensive -- audio is a
// nice-to-have and must never be able to break gameplay if it fails to load
// or play (autoplay policies, missing AudioContext support, etc.)
const SoundPlayer = {
  ctx: null,
  buffers: {},
  enabled: true,
  ready: false,
  sources: {},

  init() {
    if (this.ctx) return;
    this.sources = window.ThinklyPuzzleSounds || {};
    try {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      this.ctx = new Ctx();
      Promise.all(
        Object.entries(this.sources).map(([name, url]) =>
          this._loadBuffer(url).then((buf) => { this.buffers[name] = buf; })
        )
      ).then(() => { this.ready = true; }).catch(() => {});
    } catch (_) {
      this.ctx = null;
    }
  },

  async _loadBuffer(url) {
    const res = await fetch(url);
    const arr = await res.arrayBuffer();
    return await this.ctx.decodeAudioData(arr);
  },

  _play(name, volume) {
    if (!this.enabled || !this.ctx || !this.buffers[name]) return;
    try {
      if (this.ctx.state === 'suspended') this.ctx.resume();
      const src = this.ctx.createBufferSource();
      src.buffer = this.buffers[name];
      const gain = this.ctx.createGain();
      gain.gain.value = volume;
      src.connect(gain).connect(this.ctx.destination);
      src.start(0);
    } catch (_) {
      // never let a playback failure affect gameplay
    }
  },

  playTick() { this._play('tick', 0.5); },
  playPlace() { this._play('place', 0.65); },
  playWin() { this._play('win', 0.75); },
};

function initSoundOnFirstGesture() {
  SoundPlayer.init();
  window.removeEventListener('pointerdown', initSoundOnFirstGesture);
}
window.addEventListener('pointerdown', initSoundOnFirstGesture, { once: true });

// ======================= State =======================
let appEl = null;
let LEVELS = [];
let engine = null;
let currentLevel = 1;
let dragState = null;
let boardRect = null;
let cellPx = 0;
let timerInterval = null;
let elapsedSeconds = 0;
let levelStartTime = 0;
let pausedMs = 0;
let hiddenAt = 0;
let attemptsThisLevel = 1;
let hintsUsedThisLevel = 0;
let returnsThisLevel = 0;
let hintAvailable = false;
let won = false;
let isViewingSolvedSnapshot = false;
let windowBound = false;
let boardObserver = null;
let previouslyPlacedIds = new Set();
let ghostEl = null;
let lastSolveStats = {};
let lastTrayTapTime = 0;
let lastTrayTapPieceId = null;
const HINT_INTERVAL_SECONDS = 60;
const TAP_MOVE_THRESHOLD = 8;

function $(id) { return document.getElementById(id); }

// ======================= Header-aware layout =======================
// The site header is fixed and its height isn't constant: the announcement
// bar wraps to two lines on phones and collapses on scroll. Rather than
// hardcoding a number, find the full-width bars stuck to the top of the
// viewport and use their real bottom edge.
let lastHdr = 0;
function measureHeaderBottom() {
  if (!appEl) return 0;
  const x = Math.round(window.innerWidth / 2);
  const maxY = Math.min(400, Math.round(window.innerHeight * 0.5));
  // True if what is painted at (x, y) is site chrome (announcement bar, nav...):
  // anything that sits in a fixed (or stuck-to-top sticky) container and is not
  // the game itself. Works however deeply the theme nests its header.
  const isChrome = (y) => {
    const els = document.elementsFromPoint(x, y);
    const el = els.find((e) => e.id !== 'cursor-marble' && e.id !== 'cursor-trail');
    if (!el || el === document.documentElement || el === document.body) return false;
    if (appEl.contains(el) || el.contains(appEl)) return false;
    for (let n = el; n && n !== document.body; n = n.parentElement) {
      const pos = window.getComputedStyle(n).position;
      if (n.contains(appEl)) return false;
      if (pos === 'fixed') return true;
      if (pos === 'sticky' && n.getBoundingClientRect().top <= 4) return true;
    }
    return false;
  };
  let y = 0;
  while (y < maxY && isChrome(y)) y += 8;
  if (y >= maxY) return lastHdr; // something unexpected; keep the last good value
  let bottom = y;
  for (let k = Math.max(0, y - 7); k < y; k++) {
    if (!isChrome(k)) { bottom = k; break; }
  }
  lastHdr = bottom;
  return bottom;
}

function isGameVisible() {
  const v = $('view-game');
  return !!(v && v.classList.contains('pz-active'));
}

function syncLayout() {
  if (!appEl || !appEl.isConnected) return;
  const vh = window.innerHeight;
  const hdr = Math.min(measureHeaderBottom(), Math.round(vh * 0.5));
  appEl.style.setProperty('--pz-hdr', hdr + 'px');
  // A spacer above the app pushes it down by however much the fixed header
  // overlaps it at the top of the page. Only adjusted at the very top so the
  // page doesn't jump while someone is scrolling.
  const spacer = $('pz-spacer');
  if (spacer && window.scrollY <= 4) {
    spacer.style.height = '0px'; // measure where the app naturally sits
    const naturalTop = appEl.getBoundingClientRect().top + window.scrollY;
    const need = Math.min(240, Math.max(0, Math.ceil(hdr - naturalTop)));
    spacer.style.height = need + 'px';
  }
  if (engine && isGameVisible()) measureLayout();
}

let settleTimer = null;
function settleSync(ms) {
  clearInterval(settleTimer);
  const end = Date.now() + (ms || 900);
  syncLayout();
  settleTimer = setInterval(() => {
    syncLayout();
    if (Date.now() > end) clearInterval(settleTimer);
  }, 90);
}

// Brings the game up so it sits right under the header and fills the rest of
// the screen. The page can still scroll normally to reach the footer.
function scrollAppIntoView() {
  if (!appEl || !isGameVisible()) return;
  const hdr = measureHeaderBottom();
  const delta = Math.round(appEl.getBoundingClientRect().top - hdr);
  if (Math.abs(delta) > 2) window.scrollBy(0, delta);
}

// While a level is open, keep the announcement bar collapsed (the theme's own
// body.ann-gone state) so the board and tray get the screen space.
let annPinned = false;
let annHadClass = false;
let annObserver = null;
function pinAnnouncement(on) {
  const b = document.body;
  if (on && !annPinned) {
    annPinned = true;
    annHadClass = b.classList.contains('ann-gone');
    b.classList.add('ann-gone');
    annObserver = new MutationObserver(() => {
      if (annPinned && !b.classList.contains('ann-gone')) b.classList.add('ann-gone');
    });
    annObserver.observe(b, { attributes: true, attributeFilter: ['class'] });
  } else if (!on && annPinned) {
    annPinned = false;
    if (annObserver) { annObserver.disconnect(); annObserver = null; }
    if (!annHadClass && window.scrollY <= 40) b.classList.remove('ann-gone');
  }
}

// ======================= Boot =======================
function scopeCursorMarbleToOutsideGame() {
  const marble = $('cursor-marble');
  const trail = $('cursor-trail');
  if (!appEl || (!marble && !trail)) return;
  const hide = () => {
    if (marble) marble.style.setProperty('display', 'none', 'important');
    if (trail) trail.style.setProperty('display', 'none', 'important');
  };
  const restore = () => {
    if (marble) marble.style.removeProperty('display');
    if (trail) trail.style.removeProperty('display');
  };
  appEl.addEventListener('pointerenter', hide);
  appEl.addEventListener('pointerleave', restore);
}

// Adds ?utm_source=puzzle (etc.) to every buy link so sales from the game
// show up in analytics.
function decorateBuyLinks() {
  appEl.querySelectorAll('[data-pz-buy]').forEach((a) => {
    try {
      const u = new URL(a.getAttribute('href'), window.location.origin);
      u.searchParams.set('utm_source', 'puzzle');
      u.searchParams.set('utm_medium', 'web_game');
      u.searchParams.set('utm_campaign', a.getAttribute('data-pz-buy'));
      a.setAttribute('href', u.toString());
    } catch (_) {}
  });
}

function bindWindowListeners() {
  if (windowBound) return;
  windowBound = true;

  let trayResizeTimer = null;
  const onResize = () => {
    settleSync(500);
    if (engine && isGameVisible()) measureLayout();
    if (dragState) return; // don't re-render mid-drag
    clearTimeout(trayResizeTimer);
    trayResizeTimer = setTimeout(() => { if (engine) renderTray(); }, 150);
  };
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', () => setTimeout(onResize, 200));

  // Cached board position goes stale if the page scrolls or the header
  // collapses, so keep it fresh (and re-measure again at every drag start).
  let raf = 0;
  window.addEventListener('scroll', () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      if (dragState) return;
      syncLayout();
    });
  }, { passive: true });

  window.addEventListener('load', () => settleSync(900));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => settleSync(300));

  // The theme toggles classes on <body> as the announcement bar collapses.
  new MutationObserver(() => settleSync(900)).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Don't count time spent in a background tab.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (!hiddenAt) hiddenAt = Date.now();
    } else if (hiddenAt) {
      pausedMs += Date.now() - hiddenAt;
      hiddenAt = 0;
    }
  });
}

function boot() {
  LEVELS = LEVELS_DATA.levels;
  decorateBuyLinks();
  renderLevelSelect();
  wireGlobalEvents();
  setupInstallPrompt();
  scopeCursorMarbleToOutsideGame();
  bindWindowListeners();
  settleSync(900);
}

function init() {
  const el = document.getElementById('app');
  if (!el || el.dataset.pzInit === '1') return;
  el.dataset.pzInit = '1';
  stopTimer();
  pinAnnouncement(false);
  engine = null;
  dragState = null;
  ghostEl = null;
  won = false;
  if (boardObserver) { boardObserver.disconnect(); boardObserver = null; }
  appEl = el;
  boot();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
// Theme editor re-renders the section without reloading the page.
document.addEventListener('shopify:section:load', init);
document.addEventListener('shopify:section:unload', () => { stopTimer(); pinAnnouncement(false); });

// ======================= Routing =======================
function showView(id) {
  appEl.querySelectorAll('.pz-view').forEach((v) => v.classList.remove('pz-active'));
  $(id).classList.add('pz-active');
  const playing = id === 'view-game';
  pinAnnouncement(playing);
  settleSync(900);
  if (playing) {
    setTimeout(scrollAppIntoView, 160);
    setTimeout(scrollAppIntoView, 700);
  }
}

function goToLevelSelect() {
  stopTimer();
  renderLevelSelect();
  showView('view-level-select');
}

function goToStats() {
  renderStats();
  showView('view-stats');
}

function goToLevel(levelNumber) {
  loadLevel(levelNumber);
  showView('view-game');
}

// ======================= Level select =======================
function difficultyColor(level) {
  if (level <= 30) return '#9CC9A1';
  if (level <= 60) return '#8FB7E8';
  return '#F29B9B';
}

function renderLevelSelect() {
  const completed = ProgressStore.getCompleted();
  $('progress-summary').textContent = `${completed.size} of 88 solved · Starter to Expert`;

  const streak = StreakStore.getCurrent();
  const pill = $('streak-pill');
  if (streak > 0) {
    pill.style.display = 'flex';
    $('streak-count').textContent = streak;
  } else {
    pill.style.display = 'none';
  }

  // Buy card only appears once someone has solved at least one level.
  const buyCard = $('level-buy-card');
  if (buyCard) buyCard.style.display = completed.size >= 1 ? 'flex' : 'none';

  const grid = $('level-grid');
  grid.innerHTML = '';
  for (let i = 1; i <= 88; i++) {
    const unlocked = i === 1 || completed.has(i - 1);
    const isDone = completed.has(i);
    const level = LEVELS.find((l) => l.level === i);
    const tile = document.createElement(unlocked ? 'button' : 'div');
    tile.className = 'pz-level-tile' + (unlocked ? '' : ' pz-locked');
    if (unlocked) {
      tile.type = 'button';
      tile.setAttribute('aria-label', `Level ${i}${isDone ? ', solved' : ''}`);
      const tint = difficultyColor(i);
      const alpha = isDone ? 0.9 : 0.35;
      tile.style.background = hexToRgba(tint, alpha);
      let svg = `<svg viewBox="0 0 100 100" width="100%" height="100%" aria-hidden="true">`;
      const color = isDone ? 'rgba(255,255,255,0.6)' : 'rgba(28,27,24,0.55)';
      if (level) {
        for (const b of level.fixed_blocks) {
          const x = (b.x / 8) * 100, y = (b.y / 8) * 100, w = (b.w / 8) * 100, h = (b.h / 8) * 100;
          svg += `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="3" fill="${color}"/>`;
        }
      }
      svg += `</svg>`;
      tile.innerHTML = svg + `<span class="pz-lvl-num" style="color:${isDone ? '#fff' : '#1C1B18'}">${i}</span>`;
      tile.addEventListener('click', () => goToLevel(i));
    } else {
      tile.setAttribute('aria-label', `Level ${i}, locked`);
      tile.innerHTML = `<svg class="pz-lock-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>`;
    }
    grid.appendChild(tile);
  }
}

function hexToRgba(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

// ======================= Game: load level =======================
function resetTimerState() {
  levelStartTime = Date.now();
  pausedMs = 0;
  hiddenAt = document.hidden ? Date.now() : 0;
  elapsedSeconds = 0;
  hintsUsedThisLevel = 0;
  returnsThisLevel = 0;
  hintAvailable = false;
  $('timer-text').textContent = formatTimer(0);
  $('hint-chip').style.display = 'none';
}

function loadLevel(levelNumber) {
  const levelData = LEVELS.find((l) => l.level === levelNumber);
  if (!levelData) return;
  engine = new GameEngine(levelData);
  currentLevel = levelNumber;
  dragState = null;
  won = false;
  attemptsThisLevel = 1;
  resetTimerState();
  $('solved-overlay').classList.remove('pz-active');

  const alreadyCompleted = ProgressStore.getCompleted().has(levelNumber);
  const boardEl = $('board');
  boardEl.innerHTML = '';
  boardEl.dataset.fixedDrawn = '';
  boardEl.dataset.cellsDrawn = '';
  previouslyPlacedIds = new Set();
  if (alreadyCompleted) {
    engine.applyFullSolution();
    isViewingSolvedSnapshot = true;
    stopTimer();
  } else {
    isViewingSolvedSnapshot = false;
    startTimer();
  }

  $('game-title').textContent = `Level ${levelNumber}`;
  $('btn-share-header').style.display = isViewingSolvedSnapshot ? 'flex' : 'none';
  $('status-row').style.display = isViewingSolvedSnapshot ? 'none' : 'flex';
  renderBoard();
  renderTray();
  updateReturnZoneVisual();

  // Re-measure whenever the board's size changes (header collapse, rotation...).
  if (boardObserver) boardObserver.disconnect();
  if (window.ResizeObserver) {
    boardObserver = new ResizeObserver(() => { if (!dragState) measureLayout(); });
    boardObserver.observe(boardEl);
  }
  requestAnimationFrame(measureLayout);
}

function resetLevel() {
  if (!engine) return;
  // Rebuild from scratch so Reset can never leave stale state behind.
  engine = new GameEngine(engine.level);
  dragState = null;
  removeGhost();
  won = false;
  attemptsThisLevel++;
  isViewingSolvedSnapshot = false;
  resetTimerState();
  previouslyPlacedIds = new Set();
  $('solved-overlay').classList.remove('pz-active');
  $('btn-share-header').style.display = 'none';
  $('status-row').style.display = 'flex';
  startTimer();
  renderBoard();
  renderTray();
  requestAnimationFrame(measureLayout);
}

// ======================= Timer / hints =======================
// Elapsed time comes from timestamps (not counting setInterval ticks), minus
// any time the tab spent in the background, so the display and the saved
// solve time always agree.
function getElapsedMs() {
  const hiddenExtra = hiddenAt ? Date.now() - hiddenAt : 0;
  return Math.max(0, Date.now() - levelStartTime - pausedMs - hiddenExtra);
}

function startTimer() {
  stopTimer();
  timerInterval = setInterval(() => {
    if (won || document.hidden) return;
    elapsedSeconds = Math.floor(getElapsedMs() / 1000);
    $('timer-text').textContent = formatTimer(elapsedSeconds);
    const wasAvailable = hintAvailable;
    hintAvailable = elapsedSeconds >= (hintsUsedThisLevel + 1) * HINT_INTERVAL_SECONDS;
    $('hint-chip').style.display = hintAvailable && !won ? 'flex' : 'none';
    if (hintAvailable && !wasAvailable) {
      vibrate();
      SoundPlayer.playTick();
    }
  }, 1000);
}
function stopTimer() {
  if (timerInterval) clearInterval(timerInterval);
  timerInterval = null;
}
function formatTimer(s) {
  const m = Math.floor(s / 60), sec = s % 60;
  return `${m}:${String(sec).padStart(2, '0')}`;
}

function useHint() {
  if (!hintAvailable || !engine) return;
  const hinted = engine.applyHint();
  if (!hinted) return;
  hintsUsedThisLevel++;
  hintAvailable = false;
  $('hint-chip').style.display = 'none';
  renderBoard();
  renderTray(); // a hint can pull a block out of the tray and bump others back in
  checkWin();
}

// ======================= Rendering: board =======================
function renderBoard() {
  const boardEl = $('board');
  if (!engine) { boardEl.innerHTML = ''; return; }
  const n = engine.boardSize;

  if (!boardEl.dataset.cellsDrawn) {
    for (let yy = 0; yy < n; yy++) {
      for (let xx = 0; xx < n; xx++) {
        const cell = document.createElement('div');
        cell.className = 'pz-board-cell';
        positionBlockEl(cell, xx, yy, 1, 1, n);
        boardEl.appendChild(cell);
      }
    }
    boardEl.dataset.cellsDrawn = '1';
  }

  if (!boardEl.dataset.fixedDrawn) {
    for (const b of engine.level.fixed_blocks) {
      boardEl.appendChild(makeBlockEl(b.x, b.y, b.w, b.h, n, FIXED_BLOCK_COLOR, 'fixed'));
    }
    boardEl.dataset.fixedDrawn = '1';
  }

  const currentlyPlacedIds = new Set();
  for (const pp of engine.pieces) {
    if (!pp.placed) continue;
    currentlyPlacedIds.add(pp.piece.id);
    const w = engine.width(pp.piece, pp.rotated);
    const h = engine.height(pp.piece, pp.rotated);
    let el = boardEl.querySelector(`.pz-block[data-piece-id="${pp.piece.id}"]`);
    const isNewPlacement = !previouslyPlacedIds.has(pp.piece.id);
    if (!el) {
      el = makeBlockEl(pp.x, pp.y, w, h, n, pieceColor(pp.piece.id), 'placed');
      el.dataset.pieceId = pp.piece.id;
      boardEl.appendChild(el);
    } else {
      positionBlockEl(el, pp.x, pp.y, w, h, n);
    }
    if (isNewPlacement) {
      el.classList.remove('pz-just-placed');
      void el.offsetWidth;
      el.classList.add('pz-just-placed');
    }
  }

  boardEl.querySelectorAll('.pz-block:not(.pz-fixed)').forEach((el) => {
    const id = parseInt(el.dataset.pieceId, 10);
    if (!currentlyPlacedIds.has(id)) el.remove();
  });

  previouslyPlacedIds = currentlyPlacedIds;
}

function positionBlockEl(el, x, y, w, h, n) {
  const gapPct = 0.4;
  el.style.left = `calc(${(x / n) * 100}% + ${gapPct}%)`;
  el.style.top = `calc(${(y / n) * 100}% + ${gapPct}%)`;
  el.style.width = `calc(${(w / n) * 100}% - ${gapPct * 2}%)`;
  el.style.height = `calc(${(h / n) * 100}% - ${gapPct * 2}%)`;
}

function makeBlockEl(x, y, w, h, n, color, kind) {
  const el = document.createElement('div');
  el.className = 'pz-block' + (kind === 'fixed' ? ' pz-fixed' : '');
  positionBlockEl(el, x, y, w, h, n);
  el.style.background = color;
  return el;
}

function renderTray() {
  const tray = $('tray-grid');
  tray.innerHTML = '';
  if (!engine) return;
  // Compact tiles on phones, bigger ones in the desktop layout.
  const iconMax = window.matchMedia('(min-width: 1000px)').matches ? 46 : 30;
  for (const pp of engine.pieces) {
    if (pp.placed) continue;
    const el = document.createElement('div');
    el.className = 'pz-tray-piece';
    el.dataset.pieceId = pp.piece.id;
    el.setAttribute('role', 'img');
    el.setAttribute('aria-label', `Block ${pp.piece.baseW} by ${pp.piece.baseH}`);
    const w = engine.width(pp.piece, pp.rotated);
    const h = engine.height(pp.piece, pp.rotated);
    const maxDim = Math.max(w, h);
    const shape = document.createElement('div');
    shape.className = 'pz-shape-icon';
    shape.style.background = pieceColor(pp.piece.id);
    shape.style.width = `${(w / maxDim) * iconMax}px`;
    shape.style.height = `${(h / maxDim) * iconMax}px`;
    const label = document.createElement('div');
    label.className = 'pz-size-label';
    label.textContent = `${pp.piece.baseW}\u00d7${pp.piece.baseH}`;
    el.appendChild(shape);
    el.appendChild(label);
    tray.appendChild(el);
  }
}

function measureLayout() {
  const boardEl = $('board');
  if (!boardEl) return;
  const r = boardEl.getBoundingClientRect();
  if (r.width === 0) return; // board is hidden (another view is showing)
  boardRect = r;
  cellPx = r.width / (engine ? engine.boardSize : 8);
}

// ======================= Ghost (dragged piece visual) =======================
function showGhost(colorHex) {
  removeGhost();
  ghostEl = document.createElement('div');
  ghostEl.className = 'pz-ghost';
  ghostEl.style.background = colorHex;
  appEl.appendChild(ghostEl);
}
function updateGhost(x, y, wPx, hPx, opacity) {
  if (!ghostEl) return;
  ghostEl.style.left = `${x - wPx / 2}px`;
  ghostEl.style.top = `${y - hPx / 2}px`;
  ghostEl.style.width = `${wPx}px`;
  ghostEl.style.height = `${hPx}px`;
  ghostEl.style.opacity = opacity;
}
function removeGhost() {
  if (ghostEl) { ghostEl.remove(); ghostEl = null; }
}

function updateReturnZoneVisual(highlighted, hovering) {
  const rz = $('return-zone');
  rz.classList.toggle('pz-highlighted', !!highlighted);
  rz.classList.toggle('pz-hovering', !!hovering);
  $('return-zone-label').textContent = hovering ? 'Release to send back' : 'Drag a placed block here to remove it';
}

// ======================= Drag: board pieces =======================
function boardPointFromEvent(e) {
  return { x: e.clientX - boardRect.left, y: e.clientY - boardRect.top };
}

function cellFromBoardPoint(px, py) {
  const gx = Math.floor((px / boardRect.width) * engine.boardSize);
  const gy = Math.floor((py / boardRect.height) * engine.boardSize);
  return { gx: Math.min(Math.max(gx, 0), engine.boardSize - 1), gy: Math.min(Math.max(gy, 0), engine.boardSize - 1) };
}

function computeTargetCell(fingerX, fingerY, pieceWPx, pieceHPx) {
  if (!boardRect) return null;
  const margin = cellPx * 1.0;
  const localX = fingerX - boardRect.left;
  const localY = fingerY - boardRect.top;
  const overBoard = localX >= -margin && localX <= boardRect.width + margin && localY >= -margin && localY <= boardRect.height + margin;
  if (!overBoard) return null;
  const wCells = Math.round(pieceWPx / cellPx);
  const hCells = Math.round(pieceHPx / cellPx);
  const topLeftX = fingerX - pieceWPx / 2 - boardRect.left;
  const topLeftY = fingerY - pieceHPx / 2 - boardRect.top;
  let gx = Math.round(topLeftX / cellPx);
  let gy = Math.round(topLeftY / cellPx);
  gx = Math.min(Math.max(gx, 0), engine.boardSize - wCells);
  gy = Math.min(Math.max(gy, 0), engine.boardSize - hCells);
  return { gx, gy };
}

function wireGlobalEvents() {
  const board = $('board');

  let lastTapTime = 0;
  let lastTapPieceId = null;
  let pendingPickup = null;

  board.addEventListener('pointerdown', (e) => {
    if (!engine || isViewingSolvedSnapshot) return;
    measureLayout(); // always work from the board's current position
    if (!boardRect) return;
    const pt = boardPointFromEvent(e);
    const { gx, gy } = cellFromBoardPoint(pt.x, pt.y);
    const pp = engine.pieceAt(gx, gy);
    if (!pp) return;
    e.preventDefault();
    pendingPickup = { pp, startX: e.clientX, startY: e.clientY, moved: false };
    board.setPointerCapture(e.pointerId);
  });

  board.addEventListener('pointermove', (e) => {
    if (pendingPickup && !pendingPickup.moved) {
      const dx = e.clientX - pendingPickup.startX, dy = e.clientY - pendingPickup.startY;
      if (Math.hypot(dx, dy) > TAP_MOVE_THRESHOLD) {
        pendingPickup.moved = true;
        startDragFromBoard(pendingPickup.pp, e.clientX, e.clientY);
      }
    }
    if (!dragState) return;
    e.preventDefault();
    updateDrag(e.clientX, e.clientY);
  });

  board.addEventListener('pointerup', () => {
    if (dragState) {
      endDrag();
      pendingPickup = null;
      return;
    }
    if (pendingPickup && !pendingPickup.moved) {
      const pp = pendingPickup.pp;
      const now = Date.now();
      if (lastTapPieceId === pp.piece.id && now - lastTapTime < 300) {
        lastTapTime = 0;
        lastTapPieceId = null;
        rotatePlacedInPlace(pp);
      } else {
        lastTapTime = now;
        lastTapPieceId = pp.piece.id;
      }
    }
    pendingPickup = null;
  });
  board.addEventListener('pointercancel', () => {
    if (dragState) cancelDrag();
    pendingPickup = null;
  });

  $('btn-back-to-select').addEventListener('click', goToLevelSelect);
  $('btn-reset').addEventListener('click', resetLevel);
  $('btn-open-stats').addEventListener('click', goToStats);
  $('btn-back-from-stats').addEventListener('click', goToLevelSelect);
  $('hint-chip').addEventListener('click', useHint);
  $('btn-next-level').addEventListener('click', () => {
    if (currentLevel < 88) goToLevel(currentLevel + 1);
    else goToLevelSelect();
  });
  $('btn-level-select-from-win').addEventListener('click', goToLevelSelect);
  $('btn-share-win').addEventListener('click', () => shareSolvedLevel(lastSolveStats));
  $('btn-share-header').addEventListener('click', () => {
    const record = AnalyticsStore.getMostRecentForLevel(currentLevel);
    shareSolvedLevel(record ? { timeMs: record.timeMs, attempts: record.attempts, hints: record.hintsUsed } : {});
  });

  $('btn-open-help').addEventListener('click', () => {
    $('help-modal').classList.add('pz-active');
  });
  $('btn-close-help').addEventListener('click', () => $('help-modal').classList.remove('pz-active'));
  $('help-modal').addEventListener('click', (e) => {
    if (e.target.id === 'help-modal') $('help-modal').classList.remove('pz-active');
  });

  wireTrayEvents();
}

// Rotates a placed piece in-place where possible. If the rotated footprint
// doesn't fit at the exact same top-left corner, this searches a small
// neighbourhood around that corner (up/left first, radius 3), matching the
// Android app. If nothing nearby works the piece stays exactly as it was.
function tryRotateWithNudge(pp) {
  if (pp.piece.baseW === pp.piece.baseH) return false;
  const ox = pp.x, oy = pp.y;
  const oldRotated = pp.rotated;
  const oldW = engine.width(pp.piece, oldRotated);
  const oldH = engine.height(pp.piece, oldRotated);
  const newRotated = !oldRotated;
  const newW = engine.width(pp.piece, newRotated);
  const newH = engine.height(pp.piece, newRotated);

  engine.removeFromGrid(pp);

  // Math.trunc (not floor) matches Kotlin's Int division.
  const idealX = ox + Math.trunc((oldW - newW) / 2);
  const idealY = oy + Math.trunc((oldH - newH) / 2);

  const seen = new Set();
  const candidates = [];
  const addCandidate = (x, y) => {
    const key = `${x},${y}`;
    if (!seen.has(key)) { seen.add(key); candidates.push({ x, y }); }
  };
  addCandidate(ox, oy);
  addCandidate(idealX, idealY);
  const searchRadius = 3;
  for (let d = 1; d <= searchRadius; d++) {
    addCandidate(idealX, idealY - d);         // up
    addCandidate(idealX - d, idealY);         // left
    addCandidate(idealX - d, idealY - d);     // up-left
    addCandidate(idealX, idealY + d);         // down
    addCandidate(idealX + d, idealY);         // right
    addCandidate(idealX + d, idealY + d);     // down-right
    addCandidate(idealX - d, idealY + d);     // down-left
    addCandidate(idealX + d, idealY - d);     // up-right
  }

  for (const c of candidates) {
    if (engine.place(pp, c.x, c.y, newRotated)) return true;
  }

  engine.place(pp, ox, oy, oldRotated);
  return false;
}

function rotatePlacedInPlace(pp) {
  if (pp.piece.baseW === pp.piece.baseH) return;
  tryRotateWithNudge(pp);
  vibrate();
  SoundPlayer.playTick();
  renderBoard();
  checkWin();
}

function startDragFromBoard(pp, clientX, clientY) {
  const ox = pp.x, oy = pp.y;
  engine.removeFromGrid(pp);
  dragState = { pieceId: pp.piece.id, rotated: pp.rotated, fromBoard: true, originX: ox, originY: oy, fingerX: clientX, fingerY: clientY };
  renderBoard();
  const w = engine.width(pp.piece, pp.rotated) * cellPx;
  const h = engine.height(pp.piece, pp.rotated) * cellPx;
  showGhost(pieceColor(pp.piece.id));
  updateGhost(clientX, clientY, w * 1.06, h * 1.06, 0.92);
  updateReturnZoneVisual(true, false);
  vibrate();
  SoundPlayer.playTick();
}

function updateDrag(clientX, clientY) {
  dragState.fingerX = clientX;
  dragState.fingerY = clientY;
  const pp = engine.pieces.find((p) => p.piece.id === dragState.pieceId);
  const w = engine.width(pp.piece, dragState.rotated) * cellPx;
  const h = engine.height(pp.piece, dragState.rotated) * cellPx;
  const overReturnZone = isOverReturnZone(clientX, clientY) && dragState.fromBoard;
  const scale = overReturnZone ? 0.85 : 1.06;
  updateGhost(clientX, clientY, w * scale, h * scale, overReturnZone ? 0.6 : 0.92);
  updateReturnZoneVisual(dragState.fromBoard, overReturnZone);

  // Live valid/invalid highlight, using the same snap logic as the drop.
  if (ghostEl) {
    if (overReturnZone) {
      ghostEl.classList.remove('pz-preview-valid', 'pz-preview-invalid');
    } else {
      const target = computeTargetCell(clientX, clientY, w, h);
      if (target) {
        const valid = engine.canPlace(pp, target.gx, target.gy, dragState.rotated);
        ghostEl.classList.toggle('pz-preview-valid', valid);
        ghostEl.classList.toggle('pz-preview-invalid', !valid);
      } else {
        ghostEl.classList.remove('pz-preview-valid', 'pz-preview-invalid');
      }
    }
  }
}

// Measured fresh on every check, with a forgiving margin. The whole tray
// column also counts as a drop target for removing a block.
function isOverReturnZone(x, y) {
  const rz = $('return-zone');
  const trayCol = appEl.querySelector('.pz-game-tray-col');
  const pad = 18;
  if (rz) {
    const r = rz.getBoundingClientRect();
    if (x >= r.left - pad && x <= r.right + pad && y >= r.top - pad && y <= r.bottom + pad) return true;
  }
  if (trayCol) {
    const t = trayCol.getBoundingClientRect();
    if (x >= t.left && x <= t.right && y >= t.top && y <= t.bottom) return true;
  }
  return false;
}

function endDrag() {
  const ds = dragState;
  if (!ds) return;
  const pp = engine.pieces.find((p) => p.piece.id === ds.pieceId);
  const overReturnZone = isOverReturnZone(ds.fingerX, ds.fingerY) && ds.fromBoard;

  let outcome = false;
  if (overReturnZone) {
    returnsThisLevel++;
    outcome = true;
  } else {
    const w = engine.width(pp.piece, ds.rotated) * cellPx;
    const h = engine.height(pp.piece, ds.rotated) * cellPx;
    const target = computeTargetCell(ds.fingerX, ds.fingerY, w, h);
    let placedOk = false;
    if (target) placedOk = engine.place(pp, target.gx, target.gy, ds.rotated);
    if (!placedOk && ds.fromBoard) engine.place(pp, ds.originX, ds.originY, ds.rotated);
    outcome = placedOk;
  }

  dragState = null;
  removeGhost();
  updateReturnZoneVisual(false, false);
  renderBoard();
  renderTray();
  if (outcome) { vibrate(); SoundPlayer.playPlace(); }
  if (!overReturnZone) checkWin();
}

function cancelDrag() {
  const ds = dragState;
  if (!ds) return;
  const pp = engine.pieces.find((p) => p.piece.id === ds.pieceId);
  if (ds.fromBoard && pp) engine.place(pp, ds.originX, ds.originY, ds.rotated);
  dragState = null;
  removeGhost();
  updateReturnZoneVisual(false, false);
  renderBoard();
  renderTray();
}

// ======================= Drag: tray pieces =======================
function wireTrayEvents() {
  const trayGrid = $('tray-grid');
  let active = null;

  trayGrid.addEventListener('pointerdown', (e) => {
    const el = e.target.closest('.pz-tray-piece');
    if (!el || !engine) return;
    e.preventDefault();
    measureLayout(); // always work from the board's current position
    const pieceId = parseInt(el.dataset.pieceId, 10);
    active = { pieceId, startX: e.clientX, startY: e.clientY, moved: false, pointerId: e.pointerId };
    trayGrid.setPointerCapture(e.pointerId);
  });

  trayGrid.addEventListener('pointermove', (e) => {
    if (!active) return;
    const dx = e.clientX - active.startX, dy = e.clientY - active.startY;
    if (!active.moved && Math.hypot(dx, dy) > TAP_MOVE_THRESHOLD) {
      active.moved = true;
      const pp = engine.pieces.find((p) => p.piece.id === active.pieceId);
      if (!pp || pp.placed) { active = null; return; }
      dragState = { pieceId: pp.piece.id, rotated: pp.rotated, fromBoard: false, fingerX: e.clientX, fingerY: e.clientY };
      const w = engine.width(pp.piece, pp.rotated) * cellPx;
      const h = engine.height(pp.piece, pp.rotated) * cellPx;
      showGhost(pieceColor(pp.piece.id));
      updateGhost(e.clientX, e.clientY, w * 1.06, h * 1.06, 0.92);
      vibrate();
      SoundPlayer.playTick();
    }
    if (dragState && active && active.moved) {
      updateDrag(e.clientX, e.clientY);
    }
  });

  trayGrid.addEventListener('pointerup', () => {
    if (!active) return;
    if (active.moved && dragState) {
      const dsPiece = engine.pieces.find((p) => p.piece.id === dragState.pieceId);
      const w2 = engine.width(dsPiece.piece, dragState.rotated) * cellPx;
      const h2 = engine.height(dsPiece.piece, dragState.rotated) * cellPx;
      const target = computeTargetCell(dragState.fingerX, dragState.fingerY, w2, h2);
      let placedOk = false;
      if (target) placedOk = engine.place(dsPiece, target.gx, target.gy, dragState.rotated);
      dragState = null;
      removeGhost();
      updateReturnZoneVisual(false, false);
      renderBoard();
      renderTray();
      if (placedOk) { vibrate(); SoundPlayer.playPlace(); }
      checkWin();
    } else if (!active.moved) {
      const now = Date.now();
      if (lastTrayTapPieceId === active.pieceId && now - lastTrayTapTime < 300) {
        lastTrayTapTime = 0;
        lastTrayTapPieceId = null;
        const pp = engine.pieces.find((p) => p.piece.id === active.pieceId);
        if (pp && !pp.placed && pp.piece.baseW !== pp.piece.baseH) {
          pp.rotated = !pp.rotated;
          vibrate();
          SoundPlayer.playTick();
          renderTray();
        }
      } else {
        lastTrayTapTime = now;
        lastTrayTapPieceId = active.pieceId;
      }
    }
    active = null;
  });

  trayGrid.addEventListener('pointercancel', () => {
    if (dragState) cancelDrag();
    active = null;
  });
}

function vibrate() {
  try {
    if (navigator.vibrate) navigator.vibrate(8);
  } catch (_) {}
}

// ======================= Win handling =======================
function checkWin() {
  if (!engine || won) return;
  if (!engine.isComplete()) return;
  won = true;
  stopTimer();
  SoundPlayer.playWin();

  const elapsed = getElapsedMs();
  let newAchievements = [];
  try {
    const firstCompletion = !ProgressStore.getCompleted().has(currentLevel);
    ProgressStore.markCompleted(currentLevel);
    const totalSolved = ProgressStore.getCompleted().size; // unique levels
    const streak = StreakStore.recordPlayToday();

    AnalyticsStore.recordSolve({
      level: currentLevel,
      difficulty: engine.level.difficulty,
      attempts: attemptsThisLevel,
      timeMs: elapsed,
      hintsUsed: hintsUsedThisLevel,
      returnsUsed: returnsThisLevel,
    });

    newAchievements = AchievementsStore.checkAfterSolve({
      totalSolved,
      hintsUsedThisLevel,
      attemptsThisLevel,
      solveTimeMs: elapsed,
      currentStreak: streak,
      firstCompletion,
    });
  } catch (e) {
    console.warn('Could not save progress', e);
  }

  lastSolveStats = { timeMs: elapsed, attempts: attemptsThisLevel, hints: hintsUsedThisLevel, returns: returnsThisLevel };
  showSolvedOverlay(lastSolveStats, newAchievements);
}

function showSolvedOverlay(stats, newAchievements) {
  $('solved-sub').textContent = `Level ${currentLevel} complete`;
  const chipRow = $('solved-chips');
  chipRow.innerHTML = '';
  chipRow.appendChild(makeChip(formatSolveTime(stats.timeMs)));
  chipRow.appendChild(makeChip(`${stats.attempts} attempt${stats.attempts === 1 ? '' : 's'}`));
  if (stats.hints > 0) chipRow.appendChild(makeChip(`${stats.hints} hint${stats.hints === 1 ? '' : 's'}`));
  if (stats.returns > 0) chipRow.appendChild(makeChip(`${stats.returns} removed`));

  const banner = $('achievement-banner');
  if (newAchievements.length > 0) {
    banner.style.display = 'block';
    banner.innerHTML = `<div class="pz-ab-title">Achievement unlocked!</div>` +
      newAchievements.map((a) => `<div class="pz-ab-item">\u2022 ${a.title} \u2014 ${a.description}</div>`).join('');
  } else {
    banner.style.display = 'none';
  }

  $('btn-next-level').textContent = currentLevel >= 88 ? 'Done' : 'Next level';
  $('solved-overlay').classList.add('pz-active');
  runConfetti();
}

function makeChip(text) {
  const c = document.createElement('div');
  c.className = 'pz-chip';
  c.textContent = text;
  return c;
}

function formatSolveTime(ms) {
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60), s = totalSec % 60;
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
}

// ======================= Confetti =======================
function runConfetti() {
  const canvas = $('confetti-canvas');
  const overlay = $('solved-overlay');
  canvas.width = overlay.clientWidth;
  canvas.height = overlay.clientHeight;
  const ctx = canvas.getContext('2d');
  const colors = PIECE_COLORS;
  const particles = Array.from({ length: 28 }, () => ({
    x: Math.random() * canvas.width,
    delay: Math.random() * 0.3,
    drift: (Math.random() - 0.5) * canvas.width * 0.4,
    color: colors[Math.floor(Math.random() * colors.length)],
    size: 5 + Math.random() * 6,
    circle: Math.random() < 0.5,
  }));
  const startX = particles.map((p) => p.x);
  const start = performance.now();
  const duration = 1600;

  function frame(now) {
    const t = Math.min(1, (now - start) / duration);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let i = 0; i < particles.length; i++) {
      const p = particles[i];
      const localT = Math.min(1, Math.max(0, (t - p.delay) / (1 - p.delay)));
      if (localT <= 0) continue;
      const x = startX[i] + p.drift * localT;
      const y = localT * canvas.height * 1.05;
      const alpha = Math.max(0, 1 - localT * localT);
      ctx.globalAlpha = alpha;
      ctx.fillStyle = p.color;
      if (p.circle) {
        ctx.beginPath();
        ctx.arc(x, y, p.size / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        ctx.fillRect(x - p.size / 2, y - p.size / 2, p.size, p.size);
      }
    }
    ctx.globalAlpha = 1;
    if (t < 1) requestAnimationFrame(frame);
    else ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
  requestAnimationFrame(frame);
}

// ======================= Share =======================
function shareSolvedLevel(stats) {
  try {
    const canvas = buildShareCard(stats || {});
    canvas.toBlob(async (blob) => {
      if (!blob) return;
      try {
        const file = new File([blob], `thinkly_level_${currentLevel}.png`, { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({
            files: [file],
            title: 'Thinkly Puzzle',
            text: `I solved level ${currentLevel} in Thinkly Puzzle!`,
          });
        } else {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `thinkly_level_${currentLevel}.png`;
          a.click();
          setTimeout(() => URL.revokeObjectURL(url), 5000);
        }
      } catch (_) {
        // Share sheet dismissed or unsupported; nothing to do.
      }
    }, 'image/png');
  } catch (e) {
    console.warn('share failed', e);
  }
}

function buildShareCard(stats) {
  const canvas = document.createElement('canvas');
  canvas.width = 900;
  canvas.height = 1150;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#F7F5F0';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = '#1C1B18';
  ctx.font = "700 54px 'DM Serif Display', serif";
  ctx.fillText('thinkly', 48, 100);

  ctx.fillStyle = '#C98A2C';
  ctx.font = '700 40px Inter, sans-serif';
  ctx.fillText(`Level ${currentLevel} \u00b7 Solved!`, 48, 160);

  const n = engine.boardSize;
  const margin = 60, top = 220, boardPx = canvas.width - margin * 2;
  const cell = boardPx / n;
  const gap = cell * 0.05;
  const radius = cell * 0.16;

  function roundRect(x, y, w, h, r, color) {
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
    ctx.fill();
  }

  for (const b of engine.level.fixed_blocks) {
    roundRect(margin + b.x * cell + gap, top + b.y * cell + gap, b.w * cell - gap * 2, b.h * cell - gap * 2, radius, FIXED_BLOCK_COLOR);
  }
  for (const pp of engine.pieces) {
    if (!pp.placed) continue;
    const w = engine.width(pp.piece, pp.rotated), h = engine.height(pp.piece, pp.rotated);
    roundRect(margin + pp.x * cell + gap, top + pp.y * cell + gap, w * cell - gap * 2, h * cell - gap * 2, radius, pieceColor(pp.piece.id));
  }

  let statsY = top + boardPx + 80;
  ctx.fillStyle = '#1C1B18';
  ctx.font = '700 38px Inter, sans-serif';
  const parts = [];
  if (stats.timeMs != null) parts.push(formatSolveTime(stats.timeMs));
  if (stats.attempts != null) parts.push(`${stats.attempts} attempt${stats.attempts === 1 ? '' : 's'}`);
  if (stats.hints) parts.push(`${stats.hints} hint${stats.hints === 1 ? '' : 's'}`);
  ctx.fillText(parts.join('   \u00b7   '), margin, statsY);

  statsY += 60;
  ctx.fillStyle = '#6B675E';
  ctx.font = '400 28px Inter, sans-serif';
  ctx.fillText('A daily workout for your spatial thinking.', margin, statsY);

  return canvas;
}

// ======================= Stats screen =======================
function renderStats() {
  const el = $('stats-content');
  const summary = AnalyticsStore.getSummary();
  const solvedCount = ProgressStore.getCompleted().size; // unique levels
  const currentStreak = StreakStore.getCurrent();
  const longestStreak = StreakStore.getLongest();
  const unlocked = AchievementsStore.getUnlocked();
  const skills = CognitiveReport.compute();

  let html = '';
  html += `<div class="pz-stat-row">
    <div class="pz-stat-card"><div class="pz-value">${currentStreak} day${currentStreak === 1 ? '' : 's'}</div><div class="pz-label">Current streak</div></div>
    <div class="pz-stat-card"><div class="pz-value">${longestStreak} day${longestStreak === 1 ? '' : 's'}</div><div class="pz-label">Longest streak</div></div>
  </div>`;

  if (solvedCount === 0 && summary.totalPlays === 0) {
    html += `<p class="pz-empty-note">Solve a few puzzles and your stats will show up here.</p>`;
  } else {
    html += `<div class="pz-stat-row">
      <div class="pz-stat-card"><div class="pz-value">${solvedCount}/88</div><div class="pz-label">Solved</div></div>
      <div class="pz-stat-card"><div class="pz-value">${formatSolveTime(summary.avgTimeMs)}</div><div class="pz-label">Avg. time</div></div>
    </div>
    <div class="pz-stat-row">
      <div class="pz-stat-card"><div class="pz-value">${summary.fastestSolveMs != null ? formatSolveTime(summary.fastestSolveMs) : '-'}</div><div class="pz-label">Fastest solve</div></div>
      <div class="pz-stat-card"><div class="pz-value">${summary.totalAttempts}</div><div class="pz-label">Total attempts</div></div>
    </div>
    <div class="pz-stat-row">
      <div class="pz-stat-card"><div class="pz-value">${summary.totalHints}</div><div class="pz-label">Hints used</div></div>
      <div class="pz-stat-card"><div class="pz-value">${summary.totalReturns}</div><div class="pz-label">Blocks removed</div></div>
    </div>`;
  }

  if (skills.length > 0) {
    html += `<div class="pz-section-title">Brain engagement</div>
    <p class="pz-section-sub">A gamified estimate based on your play patterns \u2014 attempts, speed, hints, and consistency. Not a medical or scientific measurement.</p>`;
    for (const s of skills) {
      html += `<div class="pz-skill-row">
        <div class="pz-skill-head"><span>${s.name}</span><span class="pz-score">${s.score}</span></div>
        <div class="pz-skill-bar-bg"><div class="pz-skill-bar-fill" style="width:${s.score}%"></div></div>
        <div class="pz-skill-desc">${s.description}</div>
      </div>`;
    }
  }

  html += `<div class="pz-section-title">Achievements (${unlocked.size}/${ALL_ACHIEVEMENTS.length})</div>
    <div class="pz-achv-grid">`;
  for (const a of ALL_ACHIEVEMENTS) {
    const isUnlocked = unlocked.has(a.id);
    html += `<div class="pz-achv-badge${isUnlocked ? '' : ' pz-locked'}">
      <div class="pz-achv-icon">${isUnlocked ? trophySvg() : lockSvg()}</div>
      <div class="pz-achv-title">${a.title}</div>
      <div class="pz-achv-desc">${a.description}</div>
    </div>`;
  }
  html += `</div>`;

  el.innerHTML = html;
}

function trophySvg() {
  return `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C98A2C" stroke-width="2"><path d="M8 21h8M12 17v4M7 4h10v4a5 5 0 0 1-10 0V4z"/><path d="M7 5H4a3 3 0 0 0 3 3M17 5h3a3 3 0 0 1-3 3"/></svg>`;
}
function lockSvg() {
  return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6B675E" stroke-width="2"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>`;
}

// ======================= PWA install prompt =======================
let deferredInstallPrompt = null;
function setupInstallPrompt() {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredInstallPrompt = e;
    if (!SafeStorage.get('thinkly_install_dismissed')) {
      $('install-banner').classList.add('pz-active');
    }
  });
  $('btn-install').addEventListener('click', async () => {
    $('install-banner').classList.remove('pz-active');
    if (deferredInstallPrompt) {
      deferredInstallPrompt.prompt();
      await deferredInstallPrompt.userChoice;
      deferredInstallPrompt = null;
    }
  });
  $('btn-dismiss-install').addEventListener('click', () => {
    $('install-banner').classList.remove('pz-active');
    SafeStorage.set('thinkly_install_dismissed', '1');
  });
}

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-research-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Scroll progress bar
  var thinklyProgressBar = document.getElementById('read-progress');
  if (thinklyProgressBar) {
    window.addEventListener('scroll', function() {
      var scrollTop = window.scrollY;
      var docHeight = document.body.scrollHeight - window.innerHeight;
      var pct = (scrollTop / docHeight) * 100;
      thinklyProgressBar.style.width = pct + '%';
    });
  }

  // Sidebar active link tracking on scroll
  var thinklySections = document.querySelectorAll('.r-section');
  var thinklySbLinks = document.querySelectorAll('.r-sb__link');

  function thinklyUpdateActiveSidebar() {
    var activeSectionId = '';
    thinklySections.forEach(function(sec) {
      var rect = sec.getBoundingClientRect();
      if (rect.top <= 120) {
        activeSectionId = sec.id;
      }
    });
    if (!activeSectionId && thinklySections.length > 0) {
      activeSectionId = thinklySections[0].id;
    }
    if (activeSectionId) {
      thinklySbLinks.forEach(function(l) {
        l.classList.toggle('active', l.getAttribute('href') === '#' + activeSectionId);
      });
    }
  }
  window.addEventListener('scroll', thinklyUpdateActiveSidebar);
  window.addEventListener('load', thinklyUpdateActiveSidebar);

  // Smooth scroll for sidebar and summary links
  document.querySelectorAll('.r-sb__link, .r-summary__link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var targetId = link.getAttribute('href');
      var targetSection = document.querySelector(targetId);
      if (targetSection) {
        var allSections = Array.from(document.querySelectorAll('.r-section'));
        var targetIndex = allSections.indexOf(targetSection);
        for (var i = 0; i <= targetIndex; i++) {
          allSections[i].style.transition = 'none';
          allSections[i].classList.add('visible');
          allSections[i].querySelectorAll('.reveal, .reveal-left, .reveal-scale').forEach(function(el) {
            el.style.transition = 'none';
            el.classList.add('visible');
          });
        }
        document.body.offsetHeight;

        // If the target section's body is collapsed (mobile/tablet accordion), expand it
        // so the reader actually sees content after the smooth-scroll lands, not a teaser.
        var body = targetSection.querySelector('.r-section-body');
        var toggle = targetSection.querySelector('.r-toggle');
        if (body && toggle && !body.classList.contains('expanded')) {
          body.classList.add('expanded');
          toggle.setAttribute('aria-expanded', 'true');
          var label = toggle.querySelector('.r-toggle-text');
          if (label) label.textContent = 'Hide';
        }

        targetSection.scrollIntoView({ behavior: 'smooth' });
        history.pushState(null, null, targetId);
      }
    });
  });

  // Scroll reveal for left-slide and scale variants used on this page
  var thinklyResearchObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.06, rootMargin: '0px 0px -32px 0px' });

  document.querySelectorAll('.reveal-left, .reveal-scale').forEach(function(el) { thinklyResearchObs.observe(el); });

  // Accordion toggle (mobile/tablet only — buttons are hidden on desktop via CSS,
  // so this is harmless to run unconditionally on every screen size)
  document.querySelectorAll('.r-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var body = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!body) return;
      var expanded = body.classList.toggle('expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var label = toggle.querySelector('.r-toggle-text');
      if (label) label.textContent = expanded ? 'Hide' : 'Tap to read';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-skills-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Tap-to-flip — attached everywhere; the desktop CSS override (min-width:1025px)
  // forces transform:none !important on the card inner, so this is a no-op on desktop
  // regardless of whether the .tapped class gets added.
  document.querySelectorAll('.t-b-card').forEach(function (card) {
    card.addEventListener('click', function () {
      document.querySelectorAll('.t-b-card.tapped').forEach(function (c) {
        if (c !== card) c.classList.remove('tapped');
      });
      card.classList.toggle('tapped');
    });
  });

  // Arrow-driven carousel scroll (mobile/tablet only — arrows are hidden on desktop via CSS)
  document.querySelectorAll('.t-builds-carousel-wrap').forEach(function (wrap) {
    var grid = wrap.querySelector('.t-builds-grid');
    var prev = wrap.querySelector('.t-builds-arrow--prev');
    var next = wrap.querySelector('.t-builds-arrow--next');
    if (!grid || !prev || !next) return;

    function cardScrollWidth() {
      var card = grid.querySelector('.t-b-card');
      if (!card) return 280;
      var gap = parseInt(window.getComputedStyle(grid).gap || '14');
      return card.offsetWidth + gap;
    }

    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -cardScrollWidth(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      grid.scrollBy({ left: cardScrollWidth(), behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-tcard-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  var toggle = document.getElementById('t-tcard-toggle');
  var body = document.getElementById('t-tcard-body');
  if (!toggle || !body) return;

  var label = toggle.querySelector('.t-tcard-toggle-text');

  toggle.addEventListener('click', function () {
    var expanded = body.classList.toggle('expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (label) label.textContent = expanded ? 'Read less' : 'Read more';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkly-terms"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Smooth scroll for table of contents links
  document.querySelectorAll('.t-policy-toc__list a').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var targetId = link.getAttribute('href');
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
        history.pushState(null, null, targetId);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
